import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { RouteComponentProps } from 'react-router';
import { AppActions } from 'app/actions';
import { UserState } from 'app/reducers';
import { RootState } from 'app/reducers';
import { omit } from 'app/utils';
import { Card, Elevation, Button, Collapse, H4, Icon, Callout, Divider, Dialog, Intent, ProgressBar, Spinner, H1, H3, H5, Tooltip } from '@blueprintjs/core';
import './style.css';
import ReactTable from 'react-table';
import { LargeButton } from 'app/components/LargeButton';
import { DoneMarker } from 'app/components/DoneMarker';
import { NotDoneMarker } from 'app/components/NotDoneMarker';
import * as superagent from 'superagent';
import ReactCodeInput from 'react-code-input';
import { PauseScreen } from 'app/components/Simulator/PauseScreen';
import { executeQueryPostAuth, executeQueryGetAuth, getKryBase, API_BASE, API_CHARTBACK, executeInlineAuthGet, executeQueryAuthPostForm } from 'app/utils/api';
import { each, find, clone } from 'lodash';
import { GraphicView } from 'app/components/Simulator/GraphicView';
import { ClassicResultsScreen } from 'app/components/Simulator/ClassicResultsScreen';
import { ResultsScreen } from 'app/components/Simulator/ResultsScreen';
import { ClassicJournalWriter } from 'app/components/ClassicJournalWriter';
import { ClassicLPResultsScreen } from 'app/components/Simulator/ClassicLPResultsScreen';
import { JournalWriter2 } from 'app/components/JournalWriter2';
import { translateKey } from 'app/utils/forms';
import { isUserInStandardMode } from 'app/utils/user';
import { JournalWriter } from 'app/components/JournalWriter';
import ReactTimeout from 'react-timeout';
import moment from 'moment';
import { getDynamicJournalConfiguration } from 'app/utils/scores';
import { SingleOverview } from 'app/components/SingleOverview';
import { UnityPlayer } from 'app/components/UnityPlayer';
import TextAreaV2 from 'app/components/TextAreaV2';
import { LessonJournalWriter } from 'app/components/LessonJournalWriter';
import { LessonResultsScreen } from 'app/components/Simulator/LessonResultsScreen';

const VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER = 'vleader-session-at-id';
const VLEADER_SESSION_STORAGE_AUTH_TYPE_IDENTIFIER = VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER + '-type';
const VLEADER_USERNAME_KEY = 'vleader-remembered-email';

// TODO: This should be safe to remove
const KRY_URL = "https://y2eq2c3dsg.execute-api.us-east-1.amazonaws.com/dev/";

// this is the URL for the lambda portino of the kry migration
// 
const completedSpanStyle: any = {
    textAlign: 'center'
}

interface Props extends RouteComponentProps<void> {
    user: UserState;
    actions: AppActions;
}

interface State {
    showJournal: boolean;
    currentGame: string;
    loadingGame: boolean;
    pauseScreen: boolean;
    latestObjectiveData: any;
    currentScenario: string;
    currentGameMenuConfig: any | undefined;
    isOpen: any;
    graphicConfig: any | undefined;
    promptData: any;
    rootPromptData: any;
    sHowResultsScreen: boolean;
    savedPreJournal: string;
    overviewData: any;
    loadingOverviewData: boolean;
    openTabMap: any;
    classDetails: any;
    classicProgress: any;
    locallyTutorialDone: boolean;
    renderGameLocally: boolean;
    hasUnityInitalized: boolean;
    cachedSimulatedData: any;
    firstRoundData: any; // Store this till we need it
    globalConfigs: any;
    queuedPersonalCoaching: PersonalCoaching[];
    coachingDialogOpen: boolean;
    coachingOpen: boolean;
    loadingMenuConfigs: boolean;
    customMenuConfig: any;
    preJournalShim: any;
    writtenJouranl: any;
    savingShimPrompts: boolean;
    unityLoadingProgress: number;
    educatorResources: any;
    showEducatorResources: boolean;
    showYourJournal: boolean;
    modularProgress: any;
    modularLoading: boolean;
    showingReviewModule: boolean;
    renderLearningObjectives: boolean;
    renderAssessMode: boolean;
    assessModeInput: string;
    straightToSim: any;
    loadingConfig: boolean;
    remoteConfig: any;
    promptValueLookup: any;
    showCertificateWarning: boolean;
    certificateWarningEntry: any;
    showAccessCodeEntry: boolean;
    accessCodeValue: string;
    processingAccessCode: boolean;
    coachingPollingInterval: any;
    showAssessWarning: boolean;
    assessWarningEntry: any;
}

interface PersonalCoaching {
    created: string;
    createdBy: string;
    coaching: string;
    coachingID: string;
    viewed: string;
}

// Helper to check if we'r ein electron mode
function isElectron() {
    return true;
}
/*
    INTENDED FLOW:
    In portal -> Hit create game, process round 0.  
    SHow loading screen
    Send round 0 data to simulator
    SHow Loading screen
    Wait for first "onPause"
    SHow pause screen
    When user hits on resume

    We go to a full white page and wait for an "unity_onGameEnd" or "unity_onPause"

    On game end sHow results info
    On pause re-sHow the pause screen

    // Receive
    unity_onPause
    unity_getRound(roundNumber, actionString)
    unity_gameEnd

    // Send
    unity_onResume
    unity_onSetupGame    (comes with the result of createGame)
    unity_onFristRound
*/

@connect(
    (state: RootState, ownProps: any): Partial<Props> => {
        return { user: state.user };
    },
    (dispatch: Dispatch): Pick<Props, 'actions'> => ({
        actions: bindActionCreators(omit(AppActions, 'Type'), dispatch)
    })
)
export class Kry extends React.Component<Props, State> {
    static defaultProps: Partial<Props> = {

    };

    state = {
        showJournal: false,
        currentGame: '',
        loadingGame: false,
        pauseScreen: false,
        latestObjectiveData: undefined,
        currentScenario: '',
        currentGameMenuConfig: undefined,
        sHowResultsScreen: false,
        savedPreJournal: '',
        isOpen: {},
        overviewData: {},
        graphicConfig: undefined,
        loadingOverviewData: true,
        openTabMap: {},
        classDetails: {},
        promptData: undefined,
        rootPromptData: undefined,
        coachingOpen: false,
        locallyTutorialDone: false,
        classicProgress: [],
        renderGameLocally: false,
        showEducatorResources: false,
        customMenuConfig: undefined,
        cachedSimulatedData: undefined,
        loadingMenuConfigs: false,
        firstRoundData: {},
        //TODO: this should be false when we release, it's skipping the load screen for debug
        hasUnityInitalized: false,
        globalConfigs: {},
        modularProgress: undefined,
        queuedPersonalCoaching: [],
        coachingDialogOpen: false,
        preJournalShim: undefined,
        educatorResources: {},
        writtenJouranl: '',
        savingShimPrompts: false,
        modularLoading: false,
        straightToSim: undefined,
        showingReviewModule: false,
        unityLoadingProgress: 0.0,
        showYourJournal: false,
        renderLearningObjectives: false,
        renderAssessMode: false,
        assessModeInput: "",
        promptValueLookup: {},
        showCertificateWarning: false,
        certificateWarningEntry: undefined,
        showAccessCodeEntry: false,
        accessCodeValue: '',
        processingAccessCode: false,
        coachingPollingInterval: undefined,
        showAssessWarning: false,
        assessWarningEntry: undefined,
        remoteConfig: {
            categories: [],
            prompts: {},
            learning_objectives: {},
            chatgpt: {}
        },
        loadingConfig: true,
    }

    // Debug routine for showing off some regular scenario 1 lab results
    showScenario1LabResults = () => {
        const menuPayload = {
            title: "Explore Play",
            slug: "scenario_1",
            attempts: 0,
            bestPlay: 0.0,
            needsJournal: false,
            sceneType: 'coaching_journal',
            preJournalTitle: 'Plan: In 2–3 sentences, state your purpose, your approach, when you will act, and one thing you will avoid. Focus on strategy, not listing objectives.',
            postJournalTitle: 'What went right? What went wrong? How might you adjust your plan?',
            journalGraphic: 'https://vleader-ai-resources-production.s3.amazonaws.com/svg/Styles_Explore_mode_intro.svg',
            journalAudio: "https://vleader-ai-resources-production.s3.amazonaws.com/audio/Module_One_Explore_intro.wav.ogg",
            outcomeaudio: {
                additionalAudio: [
                    'https://vleader-ai-resources-production.s3.amazonaws.com/audio/All_Explore_AAR_Moveon.wav.ogg'
                ],
                good_goal: 'https://vleader-ai-resources-production.s3.amazonaws.com/audio/Module_One_Explore_AAR_Outcomes_Good.wav.ogg',
                bad_goal: 'https://vleader-ai-resources-production.s3.amazonaws.com/audio/Module_One_Explore_AAR_Outcomes_Bad.wav.ogg',
                neutral_goal: undefined,
                good_process: 'https://vleader-ai-resources-production.s3.amazonaws.com/audio/Module_One_Explore_AAR_Process_Good.wav.ogg',
                bad_process: 'https://vleader-ai-resources-production.s3.amazonaws.com/audio/Module_One_Explore_AAR_Process_Bad.wav.ogg',
                neutral_process: undefined
            }
        };

        this.setState({
            currentGame: '27dfe47b-36d8-4bd4-998c-90e5ec8ff222', // completed scenario 1 play for user 21 (student3)
            savedPreJournal: 'nothing',
            currentGameMenuConfig: menuPayload,
            sHowResultsScreen: true
        });
    }

    handleRefreshUserData = (callback?: any) => {
        const authkey = this.props.user.authenticationToken;

        executeInlineAuthGet("users/" + this.props.user.id, {}, authkey, (userDataResponse) => {

            let userResponse = userDataResponse.body;

            userResponse["authenticationToken"] = authkey; // Store the token in our state

            this.props.actions.userLogin({
                payload: userResponse
            });

            if (callback) {
                callback();
            }
        });
    }

    refreshClassicProgress = (cb?) => {
        superagent.
            get(API_CHARTBACK() + '?userID=' + this.props.user.id + '&mock=progress_overview').
            end((error: any, response: any) => {
                this.setState({
                    classicProgress: JSON.parse(response.text)
                });

                if (cb) {
                    cb();
                }
            });
    }

    loadMenuData = (classDetails) => {
        if (classDetails === undefined || classDetails === null || classDetails.client_configuration === null || classDetails.client_configuration === undefined) {
            return;
        }

        this.setState({
            loadingMenuConfigs: true,
            customMenuConfig: undefined
        });

        superagent.
            get(classDetails.client_configuration).
            end((error: any, response: any) => {
                if (error) {
                    console.log(error);
                }

                const r = JSON.parse(response.text);

                this.setState({ loadingMenuConfigs: false, customMenuConfig: r });
            });
    }

    loadInitialData = () => {
        this.setState({
            loadingOverviewData: true
        });

        if (this.props.user.classicMode === 2) {
            const currentClass = this.props.user.class.toString();

            executeQueryGetAuth("progress/user/" + this.props.user.id + "/overview", {}, this.props.user, (data) => {
                executeQueryGetAuth(`class/${currentClass}/details`, {}, this.props.user, (classDetailsResponse) => {
                    const classDetails = classDetailsResponse.body;

                    this.loadMenuData(classDetails);

                    superagent.
                        get(API_CHARTBACK() + '?userID=' + this.props.user.id + '&mock=progress_overview').
                        end((error: any, response: any) => {
                            this.setState({
                                overviewData: data.body,
                                loadingOverviewData: false,
                                classDetails: classDetails,
                                classicProgress: JSON.parse(response.text)
                            });
                        });
                });
            });
        }
        else {
            if (this.props.user.class !== "") {
                executeQueryGetAuth("progress/user/" + this.props.user.id + "/overview", {}, this.props.user, (data) => {
                    executeQueryGetAuth("class/" + this.props.user.class.toString() + "/details", {}, this.props.user, (classDetailsResponse) => {
                        const classDetails = classDetailsResponse.body;

                        this.loadMenuData(classDetails);

                        this.setState({
                            overviewData: data.body,
                            loadingOverviewData: false,
                            classDetails
                        }, () => {
                            // todo turn off when not debug
                            // this.showScenario1LabResults();
                        });
                    });
                });

                this.loadModularData();
            }
        }


    }

    recalculatePromptData = (givenConfig?) => {

        let _config = this.state.currentGameMenuConfig;

        if (givenConfig) {
            _config = givenConfig;
        }

        // choose the current scenario
        let choice = "scenario_1";

        try {
            if (_config.slug.includes("scenario_1")) {
                choice = "scenario_1";
            }
            else if (_config.slug.includes("scenario_2")) {
                choice = "scenario_2";
            }
            else if (_config.slug.includes("scenario_3")) {
                choice = "scenario_3";
            }
        }
        catch (e) {

        }

        this.setState({
            promptData: {
                ...this.state.rootPromptData,
                lab: this.state.rootPromptData.lab[choice],
            }
        })
    }

    loadModularData() {
        const baseUrl = "https://drg3dwm9kd.execute-api.us-east-1.amazonaws.com/dev/progress/modular/" + this.props.user.id;

        superagent.
            get('assets/prompts.json')
            .end((error: any, response: any) => {
                const promptData = JSON.parse(response.text);

                this.setState({
                    rootPromptData: promptData,

                })

                this.recalculatePromptData();

                superagent.
                    get(baseUrl).
                    end((error2: any, response2: any) => {
                        const r = JSON.parse(response2.text);

                        this.setState({
                            modularProgress: r
                        });
                    });

            });
    }

    checkForMissingAuthentication = () => {
        // If they hit this page before being signed in
        // forward them to the login page
        if (this.props.user) {
            if (this.props.user.authenticated === false) {
                this.props.history.push("/login?unity=true");
            }
        }
    }
    unityContext: any;

    getGlobalConfigs = () => {
        const {
            globalConfigs
        } = this.state;

        return globalConfigs ? globalConfigs : {};
    }

    loadGlobalConfigurations = () => {
        const configurationLocations = [{
            name: 'computed_coaching',
            data: 'https://vleader-ai-resources-production.s3.amazonaws.com/objectives/computed_coaching_statements.json'
        }, {
            name: 'dynamic_mc',
            data: 'https://vleader-ai-resources-production.s3.amazonaws.com/objectives/dynamic_mc_configuration.json'
        }];

        let globalConfigSoFar = {

        };

        let promises: any = [];

        for (let i = 0; i < configurationLocations.length; i++) {
            const entry = configurationLocations[i];

            promises.push(new Promise((resolve, reject) => {
                superagent.
                    get(entry.data).
                    end((error: any, response: any) => {
                        const r = JSON.parse(response.text);

                        resolve({ name: entry.name, data: r });
                    });
            }));
        }

        Promise.all(promises).then(data => {
            each(data, (d: any) => {
                globalConfigSoFar[d.name] = d.data
            });
        });

        this.setState({
            globalConfigs: globalConfigSoFar
        });
    }

    startPersonalCoachingMonitor = () => {
        this.loadPersonalCoaching();

        const monitorTime = 1000 * 60 * 5;
        //@ts-ignore
        setTimeout(this.startPersonalCoachingMonitor, monitorTime);
    }

    loadPersonalCoaching = () => {
        executeQueryGetAuth(`data/coaching/${this.props.user.id}`, {}, this.props.user, (response) => {
            try {
                const resp = JSON.parse(response.text);

                this.setState({
                    queuedPersonalCoaching: resp
                });

                // Check if there's unrated coaching and force dialog open
                const hasUnratedCoaching = this.doesCoachingQueueHaveSomething(resp);
                if (hasUnratedCoaching && !this.state.coachingOpen) {
                    this.setState({ coachingOpen: true });
                }
            }
            catch (e) {

            }
        });
    }

    setupWS = () => {
        // const ws = new WebSocket("wss://u4i9iuhy77.execute-api.us-east-1.amazonaws.com/prod");

        // const apiCall = {
        // 	event: "subscribe",
        // 	data: { channel: this.props.user.id },
        // };

        // ws.onopen = (event) => {
        //     console.log(event);

        // 	ws.send(JSON.stringify(apiCall));
        // };

        // ws.onmessage = function (event) {
        // 	console.log(event);
        // };
    }

    async loadConfigs() {
        this.setState({
            loadingConfig: true
        })

        const result = await fetch("https://configs.vleader.net/business-dev");

        const json = await result.json();

        this.setState({
            loadingConfig: false,
            remoteConfig: json
        })

        //const json = JSON.parse(text);
    }

    componentDidMount() {
        // superagent.
        //     get("assets/educator_resources.json").
        //     end((error: any, response: any) => {

        //         //@ts-ignore
        //         if (this.props.user.classicMode === 2 || this.props.user.classicMode === '2') {
        //             this.setState({ educatorResources: response.body.classic });
        //         }
        //         else {
        //             this.setState({ educatorResources: response.body.lab });
        //         }
        //     });

        this.loadConfigs().then(() => {
            executeQueryGetAuth("class/" + this.props.user.class.toString() + "/educator_resources", {}, this.props.user, (educator_resources) => {
                let er = {
                    "classic": [],
                    "lab": []
                }

                // er should ahve a title and link for each
                // the educator_resources has a url and title

                each(educator_resources.body, (erItem: any) => {
                    er["classic"].push({
                        title: erItem.title,
                        link: erItem.url
                    });

                    er["lab"].push({
                        title: erItem.title,
                        link: erItem.url
                    });
                });

                this.setState({ educatorResources: er.lab });
            });

            this.checkForMissingAuthentication();

            this.loadInitialData();

            this.loadGlobalConfigurations();

            this.startPersonalCoachingMonitor();

            this.setupWS();

            // if (window.location.host.includes('localhost')) {
            //     this.setState({
            //         hasUnityInitalized: true
            //     });
            // }

            //@ts-ignore
            window.unity_onPause = () => {
                // They requested that we sHow a pause screen
                this.setState({
                    loadingGame: false,
                    pauseScreen: true
                });

                this.showShelf();
            }

            //@ts-ignore
            window.unity_gameEnd = () => {
                this.showShelf();

                this.setState({
                    sHowResultsScreen: true,
                    renderGameLocally: false
                });
            }

            //@ts-ignore
            window.unity_tutorialBack = () => {
                this.setState({
                    locallyTutorialDone: false,
                    renderGameLocally: false,
                    showJournal: false,
                    currentGame: '',
                    loadingGame: false,
                    pauseScreen: false,
                    latestObjectiveData: undefined,
                    currentScenario: '',
                    currentGameMenuConfig: undefined,
                    sHowResultsScreen: false,
                    savedPreJournal: '',
                    overviewData: this.state.overviewData,
                    graphicConfig: undefined,
                    loadingOverviewData: false,
                    openTabMap: {}
                });

                this.showShelf();
            }

            //@ts-ignore
            window.unity_tutorialOver = () => {
                this.setState({
                    loadingGame: true,
                    locallyTutorialDone: true,
                    renderGameLocally: false
                });

                // Flag that we have finished the tutorial
                executeQueryPostAuth("users/" + this.props.user.id + "/tutorial", {}, this.props.user, () => {
                    this.handleRefreshUserData(() => {
                        this.showShelf();

                        this.setState({
                            showJournal: false,
                            currentGame: '',
                            loadingGame: false,
                            pauseScreen: false,
                            latestObjectiveData: undefined,
                            currentScenario: '',
                            currentGameMenuConfig: undefined,
                            sHowResultsScreen: false,
                            savedPreJournal: '',
                            overviewData: this.state.overviewData,
                            graphicConfig: undefined,
                            loadingOverviewData: false,
                            openTabMap: {}
                        });
                    });
                });
            }

            //@ts-ignore
            window.unity_getRound = (roundNumber: number, actionString: string) => {
                // Process a round, then return it
                this.processRoundLambda(this.state.currentGame, actionString, roundNumber, (data) => {
                    this.sendRoundData(data.text);

                    executeQueryPostAuth("data/results/" + this.state.currentGame, {}, this.props.user, (postResponse) => {
                        executeQueryGetAuth("data/results/" + this.state.currentGame, {}, this.props.user, (objectiveResponse) => {
                            const response = JSON.parse(objectiveResponse.text);

                            this.setState({
                                latestObjectiveData: response
                            });

                            this.sendObjectiveData(
                                JSON.stringify(response)
                            );
                        });
                    });
                });
            }
        });
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        // Check if coaching data has been loaded and force dialog open if there's unrated coaching
        if (this.state.queuedPersonalCoaching !== prevState.queuedPersonalCoaching) {
            const hasUnratedCoaching = this.doesCoachingQueueHaveSomething(this.state.queuedPersonalCoaching);
            if (hasUnratedCoaching && !this.state.coachingOpen) {
                this.setState({ coachingOpen: true });
            }
        }
    }

    componentWillUnmount() {
        // Clean up polling when component unmounts
        this.stopCoachingPolling();
        
        // Clean up page visibility listener
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handleVisibilityChange = () => {
        if (!document.hidden) {
            // Page became visible, check for new coaching
            console.log('Page became visible, checking for new coaching...');
            this.loadPersonalCoaching();
        }
    }

    startCoachingPolling = () => {
        // Check for new coaching every 30 seconds
        const pollingInterval = setInterval(() => {
            this.loadPersonalCoaching();
        }, 30000);

        // Store the interval ID so we can clear it later
        this.setState({ coachingPollingInterval: pollingInterval });
    }

    stopCoachingPolling = () => {
        if (this.state.coachingPollingInterval) {
            clearInterval(this.state.coachingPollingInterval);
            this.setState({ coachingPollingInterval: null });
        }
    }

    setupPageVisibilityListener = () => {
        // Check for new coaching when user returns to the tab
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    getIsSlugOpen = (slug: string) => {
        const {
            openTabMap
        } = this.state;

        if (openTabMap[slug] === undefined) {
            return false;
        }

        return openTabMap[slug];
    }

    toggleSlugOpen = (slug: string) => {
        const currentValue = this.getIsSlugOpen(slug);

        let newMap = {};

        newMap[slug] = !currentValue;

        this.setState({
            openTabMap: newMap
        });
    }

    getMetaData = () => {
        return "web-" + window["CURRENT_SOFTWARE_VERSION"];
    }

    //////
    // Helpers for game management
    createGame = (scenarioName: string, onCreate: any) => {
        this.setState({
            currentScenario: scenarioName
        });

        superagent.
            get(KRY_URL + 'create/game/' + this.props.user.id + "?scenario=" + scenarioName + "&metadata=" + this.getMetaData()).
            end((error: any, response: any) => {
                onCreate(response.body);
            });
    }

    createGame_second = (scenarioName: string, onCreate: any) => {
        /*
        scenario
        uid
        metadata
        isToCreateGame
        */

        this.setState({
            currentScenario: scenarioName
        });

        superagent.
            get(getKryBase(this.props.user) + 'kry?scenario=' + scenarioName + "&uid=" + this.props.user.id + "&metadata=" + this.getMetaData() + "&isToCreateGame=true").
            end((error: any, response: any) => {
                onCreate(response.body);
            });
    }

    sendGameInfo(gameData: string) {
        this.pushFunction("unity_onSetupGame", gameData);

        //@ts-ignore
        if (this.props.user.classicMode === "2" || this.props.user.classicMode === 2) {
            this.pushFunction("unity_getClassic", "1");
        }
        else {
            this.pushFunction("unity_getClassic", "0");
        }
    }

    showShelf() {
        this.pushFunction("unity_showSelf", "-");
    }

    processRound(gameID: string, actionString: string, previousRound: number, cb: any) {
        superagent.
            get(KRY_URL + gameID + '/do/round/single?lastRound=' + previousRound.toString() + '&standardActionQuery=' + actionString).
            end((error: any, response: any) => {
                cb(response);
            });
    }

    processRoundLambda(gameID: string, actionString: string, previousRound: number, cb: any) {
        const href = getKryBase(this.props.user) + 'kry?gameID=' + gameID + '&round=' + previousRound.toString() + '&scenarioName=' + this.state.currentScenario + '&action=' + actionString;

        superagent.
            get(href).
            end((error: any, response: any) => {
                try {
                    // Test parsing the content
                    const responseText = response.text;

                    //@ts-ignore
                    const responseAsJSON = JSON.parse(responseText);

                    cb(response);
                }
                catch (e) {
                    window.alert("There was an error processing your round.  Please try restarting the application.  If the error persists please contact support@simulearn.net");
                    throw (e);
                }
            });
    }

    pushFunction(functionName: string, argument: string) {

        if (isElectron()) {
            if (argument === "") {
                //@ts-ignore
                if (this.unityContext !== undefined) {
                    this.unityContext(
                        "WebViewBase",
                        functionName
                    );
                }
            }
            else {
                //@ts-ignore
                if (this.unityContext !== undefined) {
                    this.unityContext(
                        "WebViewBase",
                        functionName,
                        argument
                    );
                }
            }
        }
        else {
            try {
                //@ts-ignore
                window[functionName](argument);
            }
            catch { }
        }
    }

    launchScenario = (scenarioName: string) => {
        this.pushFunction("unity_launchScenario", scenarioName);
    }

    launchCard = (card: string) => {
        this.setState({
            renderGameLocally: true
        });

        this.pushFunction("unity_goCard", card);

        //@ts-ignore
        if (this.props.user.classicMode === "2" || this.props.user.classicMode === 2) {
            //@ts-ignore
            this.pushFunction("unity_getClassic", "1");
        }
        else {
            //@ts-ignore
            this.pushFunction("unity_getClassic", "0");
        }
    }

    sendRoundData = (roundData: string) => {
        this.pushFunction("unity_roundData", roundData);
    }

    sendFirstRoundData = (roundData: string) => {
        this.pushFunction("unity_onFristRound", roundData);

        // but pause it as well
        // this.showShelf();
    }

    sendPlanData = (planData: string) => {
        this.pushFunction("unity_recievePlan", planData);
    }

    sendObjectiveData = (objectiveData: string) => {
        const {
            currentGameMenuConfig
        } = this.state;

        // Check for if we're hiding objectives
        if (currentGameMenuConfig) {
            //@ts-ignore
            if (currentGameMenuConfig.blockObjectives === true) return;
        }

        // Check to see if we need to parse this
        if (isUserInStandardMode(this.props.user)) {
            let objectives = JSON.parse(objectiveData);

            for (let i = 0; i < objectives.length; i++) {
                const standardName = objectives[i].standardName;

                // If the objective has a standard name, in standard mode,
                // then use that for display
                if (standardName) {
                    objectives[i].name = standardName;
                }
            }

            objectiveData = JSON.stringify(objectives);
        }

        this.pushFunction("unity_getObjectiveData", objectiveData);
    }

    sendOnResume = () => {
        this.pushFunction("unity_onResume", "0");

        this.setState({
            pauseScreen: false,
            loadingGame: false
        });
    }

    constructor(props: Props, context?: any) {
        super(props, context);


    }

    handleTabChange = () => {

    }

    handlePortalSwitch = () => {
        window.localStorage.removeItem(
            VLEADER_SESSION_STORAGE_AUTH_TYPE_IDENTIFIER
        );

        window.location.href = "/login";
    }

    handleGameLogout = () => {
        window.localStorage.removeItem(
            VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER
        );

        window.localStorage.removeItem(
            VLEADER_SESSION_STORAGE_AUTH_TOKEN_IDENTIFIER + "--id"
        );

        window.localStorage.removeItem(
            VLEADER_SESSION_STORAGE_AUTH_TYPE_IDENTIFIER
        );

        window.localStorage.removeItem(
            VLEADER_USERNAME_KEY
        );

        this.handleGameExit();
    }

    handleGameExit = () => {
        // propogate to unity
        this.pushFunction("unity_onExit", "");
        // but also tell electron
        try {
            window.close();
        } catch (e) {
            console.log(e);
        }
    }

    handleGameCreationDirect = (scenarioName: string, cb: any, e: any) => {
        this.setState({
            loadingGame: true
        });

        this.createGame_second(scenarioName, (roundData) => {
            const data = {
                'game-id': roundData['game-id'],
                'scenario': scenarioName,
                //@ts-ignore
                'client-version': this.state.classDetails.client_version,

                'current-gender': this.props.user.gender
            }

            const gameID = data['game-id'];

            this.sendGameInfo(JSON.stringify(data));

            this.setState({
                currentGame: gameID,
                firstRoundData: roundData
            });

            // Send some initial objective data over
            executeQueryPostAuth("data/results/" + gameID, {}, this.props.user, (postResponse) => {
                executeQueryGetAuth("data/results/" + gameID, {}, this.props.user, (objectiveResponse) => {
                    const response = JSON.parse(objectiveResponse.text);

                    this.setState({
                        latestObjectiveData: response
                    });

                    this.sendObjectiveData(
                        JSON.stringify(response)
                    );
                });
            });

            //@ts-ignore
            if (this.state.currentGameMenuConfig!.sceneType === "normal") {
                //@ts-ignore
                if (window.unity_onFristRound === undefined) {
                    // If unity isn't attached to this instance, "fake" recieving the first on pause that kicks us off
                    // TODO: This could be causing our pause problem
                    // this.pushFunction("unity_onPause", "");
                }
            }



            //@ts-ignore
            if (this.state.currentGameMenuConfig!.sceneType === "coaching_journal") {
                // Render the journal input
                this.setState({
                    showJournal: true,
                    loadingGame: false
                });
            }

            this.sendOnResume();

            if (cb) {
                cb();
            }
        });
    }

    // TODO: Mark this as the real central one, that's actually in use
    // 3/23/2025
    handleGameCreation = (scenarioName: string, cb: any, e: any) => {
        this.setState({
            loadingGame: true
        });

        this.createGame_second(scenarioName, (roundData) => {
            const data = {
                'game-id': roundData['game-id'],
                'scenario': scenarioName,
                //@ts-ignore
                'client-version': this.state.classDetails.client_version,

                'current-gender': this.props.user.gender
            }

            const gameID = data['game-id'];

            this.sendGameInfo(JSON.stringify(data));

            this.setState({
                currentGame: gameID,
                firstRoundData: roundData
            });

            // Send some initial objective data over
            executeQueryPostAuth("data/results/" + gameID, {}, this.props.user, (postResponse) => {
                executeQueryGetAuth("data/results/" + gameID, {}, this.props.user, (objectiveResponse) => {
                    const response = JSON.parse(objectiveResponse.text);

                    this.setState({
                        latestObjectiveData: response
                    });

                    this.sendObjectiveData(
                        JSON.stringify(response)
                    );
                });
            });

            //@ts-ignore
            if (this.state.currentGameMenuConfig!.sceneType === "normal") {
                //@ts-ignore
                if (window.unity_onFristRound === undefined) {
                    // If unity isn't attached to this instance, "fake" recieving the first on pause that kicks us off
                    // TODO: This could be causing our pause problem
                    // this.pushFunction("unity_onPause", "");
                }
            }



            //@ts-ignore
            if (this.state.currentGameMenuConfig!.sceneType === "coaching_journal") {
                // Render the journal input
                this.setState({
                    showJournal: true,
                    loadingGame: false
                });
            }

            let inAssessPlay = false;

            //@ts-ignore
            if (scenarioName.includes("assess")) {
                inAssessPlay = true;
            }

            if (inAssessPlay) {
                this.setState({
                    pauseScreen: true,
                    loadingGame: false
                });
            }
            else {
                this.sendOnResume();
            }

            if (cb) {
                cb();
            }
        });
    }

    // Post coaching for target user
    handlePostCoaching(uid: string, coaching: string, createdBy: string, callback: any) {
        superagent.
            post(API_BASE() + 'data/coaching/post/' + uid).
            field("coaching", coaching).
            field("createdBy", createdBy).
            set('Token', this.props.user.authenticationToken).
            end((error: any, response: any) => {
                callback();
            });
    }

    handlePostCoachingRead(coachingID: string, support: string, callback: any) {
        superagent.
            post(API_BASE() + 'data/coaching/markread/' + coachingID + "?support=" + support).
            set('Token', this.props.user.authenticationToken).
            end((error: any, response: any) => {
                callback();
            });
    }

    handlePostPreFeedback(feedback: string, callback: any) {


        this.setState({
            savedPreJournal: feedback
        });

        console.log("saving pre journal", feedback);

        superagent.
            post(API_BASE() + 'data/feedback/pre/' + this.state.currentGame).
            field("feedback", feedback).
            set('Token', this.props.user.authenticationToken).
            end((error: any, response: any) => {
                callback();
            });
    }

    handlePostPostFeedback(feedback: string, callback: any) {
        superagent.
            post(API_BASE() + 'data/feedback/post/' + this.state.currentGame).
            field("feedback", feedback).
            set('Token', this.props.user.authenticationToken).
            end((error: any, response: any) => {
                callback();
            });
    }

    renderPlayButton = (items: any, item: any, itemTitle: string) => {
        const matchingEntry = find(items, item => {
            return itemTitle === item.title
        });

        let disabled = matchingEntry.enabled === false;

        // If there's unrated coaching, disable all play buttons
        const hasUnratedCoaching = this.doesCoachingQueueHaveSomething(this.state.queuedPersonalCoaching);
        if (hasUnratedCoaching) {
            disabled = true;
        }

        if (this.getIsSlugDisabledForClass(matchingEntry.slug)) {
            disabled = true;
        }

        if (matchingEntry.onlyOnce === true) {
            if (matchingEntry.attempts > 0) {
                disabled = true;
            }
        }

        // Check for a max attempts specified in the config config
        if (matchingEntry.maxAttempts) {
            if (matchingEntry.attempts >= matchingEntry.maxAttempts) {
                disabled = true;
            }
        }

        ////////////////////////
        // General control logic

        // RULE: All "onlyOnce" entries in this categories must be set to true before it's playable 
        const doesAnyEntryHaveOnce = find(items, item => {
            return item.onlyOnce === true
        });

        if (doesAnyEntryHaveOnce !== undefined) {
            // There's atleast one entry with a noOnce
            if (itemTitle !== doesAnyEntryHaveOnce.title) {
                // It isn't this entry, so don't let it play yet
                if (doesAnyEntryHaveOnce.attempts === 0) {
                    disabled = true;
                }
            }
        }

        // RULE: force them to have compeleted the tutorial first
        if (itemTitle.trim() !== "Getting Started") {
            const tutorialConfig = this.getConfigByName("Getting Started");

            if (tutorialConfig) {
                //@ts-ignore
                if (tutorialConfig!.attempts <= 0) {
                    // Add a short override to ignore this when retrieving user tutorial complete
                    if (this.state.locallyTutorialDone === false) {
                        disabled = true;
                    }
                }
            }
        }

        // Debug logging for assess scenarios
        if (matchingEntry.slug?.includes("assess")) {
            // Get explore plays count for this scenario
            let requiredExploreScenario = '';
            let explorePlaysCount = 0;
            if (matchingEntry.slug === 'scenario_1_assess') {
                requiredExploreScenario = 'scenario_1';
            } else if (matchingEntry.slug === 'scenario_2_assess') {
                requiredExploreScenario = 'scenario_2';
            } else if (matchingEntry.slug === 'scenario_3_assess') {
                requiredExploreScenario = 'scenario_3';
            }
            
            if (requiredExploreScenario) {
                explorePlaysCount = this.state.overviewData[requiredExploreScenario] ? 
                    parseInt(this.state.overviewData[requiredExploreScenario]['total-plays']) : 0;
            }
            
            console.log(`Debug assess button: ${matchingEntry.slug}`, {
                requirePurchaseCertificate: matchingEntry.requirePurchaseCertificate,
                userCertificate: this.props.user.certificate,
                disabled: disabled,
                attempts: matchingEntry.attempts,
                maxAttempts: matchingEntry.maxAttempts,
                requiredExploreScenario: requiredExploreScenario,
                explorePlaysCount: explorePlaysCount,
                title: itemTitle,
                overviewData: this.state.overviewData,
                fullEntry: matchingEntry
            });
        }

        // Certificate purchase logic
        if (matchingEntry.requirePurchaseCertificate === true) {
            // Check if user has certificate access
            const userHasCertificate = this.props.user.certificate === "1" || this.props.user.certificate === "1";
            
            // Determine which explore scenario this assess play requires
            let requiredExploreScenario = '';
            let requiredExplorePlays = 0;
            
            if (matchingEntry.slug === 'scenario_1_assess') {
                requiredExploreScenario = 'scenario_1';
            } else if (matchingEntry.slug === 'scenario_2_assess') {
                requiredExploreScenario = 'scenario_2';
            } else if (matchingEntry.slug === 'scenario_3_assess') {
                requiredExploreScenario = 'scenario_3';
            }
            
            if (requiredExploreScenario) {
                requiredExplorePlays = this.state.overviewData[requiredExploreScenario] ? 
                    parseInt(this.state.overviewData[requiredExploreScenario]['total-plays']) : 0;
            }
            
            // Check if they have enough explore plays for this specific scenario
            if (requiredExplorePlays < 2) {
                // Not enough explore plays for this specific scenario - completely disable
                disabled = true;
            } else if (!userHasCertificate) {
                // Enough explore plays but no certificate - enable so they can see purchase dialog
                disabled = false;
            }
            // If they have certificate and enough explore plays, button is enabled normally
        }

        if (matchingEntry.requiresPlaysIn !== undefined) {
            let doTheyAllHavePlays = true;

            for (let i = 0; i < matchingEntry.requiresPlaysIn.length; i++) {
                const entry = matchingEntry.requiresPlaysIn[i];

                const overviewForSlug = parseInt(this.state.overviewData[entry]['total-plays']);

                if (overviewForSlug <= 0) {
                    doTheyAllHavePlays = false;
                }

            }

            if (doTheyAllHavePlays === false) {
                disabled = true;
            }
        }

        if (matchingEntry.unlock !== undefined) {
            if (matchingEntry.unlock === '3_or_better_than_74') {
                disabled = true;

                // only make it enabled if they have 3 or more mastery plays
                // or a 74 or better in a mastery play
                const overviewsToCompare = [this.state.overviewData['scenario_1_b1'], this.state.overviewData['scenario_1_b2'], this.state.overviewData['scenario_1_b3']];
                let foundMastery = false;
                let foundThree = 0;

                for (let i = 0; i < overviewsToCompare.length; i++) {
                    const overview = overviewsToCompare[i];

                    if (overview) {
                        if (overview['best-play'] >= 74) {
                            foundMastery = true;
                        }
                        if (overview['total-plays'] >= 3) {
                            foundThree++;
                        }
                    }
                }

                if (foundMastery || foundThree >= 3) {
                    disabled = false;
                }

            }
        }

        if (matchingEntry.blockRedo === true) {
            if (matchingEntry.attempts > 0) {
                disabled = true;
            }
        }

        // Determine tooltip message for disabled buttons
        let tooltipMessage = '';
        if (disabled) {
            // Check for max attempts reached
            if (matchingEntry.maxAttempts && matchingEntry.attempts >= matchingEntry.maxAttempts) {
                tooltipMessage = `Maximum attempts reached (${matchingEntry.maxAttempts}/${matchingEntry.maxAttempts})`;
            }
            // Check for certificate requirements
            else if (matchingEntry.requirePurchaseCertificate === true) {
                const userHasCertificate = this.props.user.certificate === "1" || this.props.user.certificate === "1";
                
                if (!userHasCertificate) {
                    // Determine required scenario
                    let requiredScenario = '';
                    let scenarioName = '';
                    if (matchingEntry.slug === 'scenario_1_assess') {
                        requiredScenario = 'scenario_1';
                        scenarioName = 'Scenario 1';
                    } else if (matchingEntry.slug === 'scenario_2_assess') {
                        requiredScenario = 'scenario_2';
                        scenarioName = 'Scenario 2';
                    } else if (matchingEntry.slug === 'scenario_3_assess') {
                        requiredScenario = 'scenario_3';
                        scenarioName = 'Scenario 3';
                    }
                    
                    if (requiredScenario) {
                        const explorePlays = this.state.overviewData[requiredScenario] ? 
                            parseInt(this.state.overviewData[requiredScenario]['total-plays']) : 0;
                        
                        if (explorePlays < 2) {
                            tooltipMessage = `Complete at least 2 ${scenarioName} Explore plays to unlock this assessment`;
                        } else {
                            tooltipMessage = 'This assessment requires a certificate purchase';
                        }
                    }
                }
            }
            // Check for unrated coaching
            else if (this.doesCoachingQueueHaveSomething(this.state.queuedPersonalCoaching)) {
                tooltipMessage = 'Complete pending coaching reviews before continuing';
            }
            // Check for tutorial completion
            else if (itemTitle.trim() !== "Getting Started") {
                const tutorialConfig = this.getConfigByName("Getting Started");
                if (tutorialConfig && tutorialConfig.attempts <= 0 && this.state.locallyTutorialDone === false) {
                    tooltipMessage = 'Complete the Getting Started tutorial first';
                }
            }
        }
        
        const buttonElement = <LargeButton 
            giant={true} 
            text={itemTitle} 
            intent={Intent.PRIMARY}
            style={{ width: '100%' }}
            onClick={() => {
            // Check if this is a certificate-required assess play and user doesn't have certificate
            if (matchingEntry.requirePurchaseCertificate === true) {
                const userHasCertificate = this.props.user.certificate === "1" || this.props.user.certificate === "1";
                
                if (!userHasCertificate) {
                    // Show certificate warning dialog
                    this.setState({
                        showCertificateWarning: true,
                        certificateWarningEntry: matchingEntry
                    });
                    return;
                }
            }
            
            // Check if this assess play has a warning message
            if (matchingEntry.assessWarningText && matchingEntry.slug?.includes("assess")) {
                // Show assess warning dialog before proceeding
                this.setState({
                    showAssessWarning: true,
                    assessWarningEntry: matchingEntry
                });
                return;
            }
            
            if (matchingEntry && matchingEntry.loosePrePrompts !== undefined) {
                // We need to handle pre prompts first;
                // But only if it's actively active for this class
                if (this.props.user.class_access_dcoaching === 1) {
                    this.setState({
                        preJournalShim: {
                            matchingEntry,
                            user: { ...this.props.user }
                        }
                    })
                }
                else {
                    this.handlePlayButtonClick(matchingEntry);
                }
            }
            else {
                this.handlePlayButtonClick(matchingEntry);
            }
        }} disabled={disabled} />;
        
        // Wrap with tooltip if there's a message for disabled button
        if (disabled && tooltipMessage) {
            return <div style={{ width: '100%' }}>
                <Tooltip 
                    content={tooltipMessage} 
                    position="top" 
                    popoverClassName="full-width-tooltip"
                    targetProps={{ style: { width: '100%' } }}
                >
                    {buttonElement}
                </Tooltip>
            </div>;
        }
        
        // For debugging - let's add a simple tooltip for any disabled assess button
        if (disabled && (itemTitle.includes("Assess") || matchingEntry.slug?.includes("assess"))) {
            let debugMessage = 'This assessment is currently disabled';
            
            // Add more specific debug info
            if (matchingEntry.requirePurchaseCertificate === true) {
                debugMessage += ' (certificate required)';
            }
            if (matchingEntry.maxAttempts && matchingEntry.attempts >= matchingEntry.maxAttempts) {
                debugMessage += ` (max attempts: ${matchingEntry.attempts}/${matchingEntry.maxAttempts})`;
            }
            
            return <div style={{ width: '100%' }}>
                <Tooltip 
                    content={debugMessage} 
                    position="top" 
                    popoverClassName="full-width-tooltip"
                    targetProps={{ style: { width: '100%' } }}
                >
                    {buttonElement}
                </Tooltip>
            </div>;
        }
        
        return buttonElement;
    }

    handlePlayButtonClick = (matchingEntry: any, skipToSim?: boolean, journal?: string) => {
        this.setState({
            straightToSim: skipToSim === true ? journal : undefined
        });

        if (matchingEntry.sceneType === "review") {
            this.setState({
                showingReviewModule: true,
                currentGameMenuConfig: matchingEntry
            });
            this.recalculatePromptData(matchingEntry);
            return;
        }

        if (matchingEntry.sceneType === "assess") {
            this.setState({
                renderAssessMode: true,
                currentGameMenuConfig: matchingEntry
            });
            this.recalculatePromptData(matchingEntry);
        }
        else if (matchingEntry.sceneType === 'graphic') {
            this.setState({
                graphicConfig: matchingEntry
            });
            this.recalculatePromptData(matchingEntry);
        }
        else if (matchingEntry.sceneType === 'card') {
            this.setState({
                loadingGame: true,
                currentGameMenuConfig: matchingEntry
            });
            this.recalculatePromptData(matchingEntry);
            if (matchingEntry.title === "Getting Started") {
                this.setState({
                    renderLearningObjectives: true,
                    currentGameMenuConfig: matchingEntry
                });
                this.recalculatePromptData(matchingEntry);
            }
            else {
                // Launch the tutorial scene
                this.launchCard(matchingEntry.slug);
                this.recalculatePromptData(matchingEntry);
            }
        }
        else {
            if (matchingEntry.title === "Getting Started") {
                this.setState({
                    renderLearningObjectives: true,
                    currentGameMenuConfig: matchingEntry
                });
                this.recalculatePromptData(matchingEntry);
            }
            else {
                this.setState({
                    loadingGame: true,
                    currentGameMenuConfig: matchingEntry
                }, () => {
                    this.recalculatePromptData(matchingEntry);
                    this.handleGameCreation(matchingEntry.slug, undefined, matchingEntry);
                });
            }
        }
    }

    // TODO: Implement this
    getIsSlugDisabledForClass = (slug: string) => {
        return false;
    }

    renderFullTable = (items: any) => {
        const sectionColumns = [
            {
                Header: "",
                accessor: "name",
                Cell: (props) => {
                    return this.renderPlayButton(items, props, props.value);
                }
            },
            {
                Header: "Attempted",
                accessor: "played",
                Cell: (props) => {
                    if (props.value) {
                        return <span style={{ textAlign: 'center', display: 'block' }}><DoneMarker giant={true} /></span>
                    }
                    else {
                        return <span style={completedSpanStyle}><NotDoneMarker giant={true} /></span>
                    }
                }
            }
        ];

        // TODO: When in "normal" lab mode, we want to see the score still
        // ,
        //     {
        //         Header: "Best Play",
        //         accessor: "score"
        //     }

        let sectionData: any[] = [];

        each(items, (item: any) => {
            const {
                title,
                slug,
                attempts,
                bestPlay
            } = item;

            let foundBestPlay = bestPlay;

            if (item.hideBestPlay === true) {
                foundBestPlay = "-";
            }

            sectionData.push({
                name: title,
                slug,
                attempts: attempts,
                score: foundBestPlay,
                played: (parseInt(attempts) > 0),
            });
        });

        return <ReactTable className={"kryMinimalTable"} data={sectionData} pageSize={sectionData.length} showPageSizeOptions={false} showPagination={false} sortable={false} columns={sectionColumns} />
    }

    renderBasicTable = (items: any) => {
        const sectionColumns = [
            {
                Header: "",
                accessor: "name",
                Cell: (props) => {
                    return this.renderPlayButton(items, props, props.value);
                }
            },
            {
                Header: "Completed",
                accessor: "played",
                Cell: (props) => {
                    if (props.value) {
                        return <span style={completedSpanStyle}><DoneMarker giant={true} /></span>
                    }
                    else {
                        return <span style={completedSpanStyle}><NotDoneMarker giant={true} /></span>
                    }
                }
            }
        ];

        let sectionData: any[] = [];

        each(items, (item: any) => {
            const {
                title,
                slug,
                attempts
            } = item;


            sectionData.push({
                name: title,
                slug,
                played: (parseInt(attempts) > 0),
                action: "yes"
            });
        });

        return <ReactTable className={"kryMinimalTable"} data={sectionData} pageSize={sectionData.length} showPageSizeOptions={false} showPagination={false} sortable={false} columns={sectionColumns} />
    }

    renderPageWrapper = (children: any) => {
        return <div className="kryParent" id="kryRoot">
            <Card className="kryParentCard" interactive={false} elevation={Elevation.ONE}>
                {children}
            </Card>
        </div>
    }

    renderPause = () => {
        const {
            currentGameMenuConfig
        } = this.state;

        let pauseJournalContent = undefined;

        // is the current game menu config option an assess play
        if (currentGameMenuConfig && currentGameMenuConfig.slug.includes("assess")) {
            pauseJournalContent = this.state.assessModeInput;
        }

        return <div className="kryParent" id="kryRoot">
            <Card className="kryParentCard" interactive={false} elevation={Elevation.ONE}>
                <PauseScreen
                    user={this.props.user}
                    gameID={this.state.currentGame}
                    menuConfig={currentGameMenuConfig}
                    journalData={this.state.savedPreJournal}
                    objectiveData={this.state.latestObjectiveData}
                    //@ts-ignore
                    needsJournal={this.state.currentGameMenuConfig.needsJournal}
                    //@ts-ignore
                    prompt={this.state.currentGameMenuConfig.preJournalTitle}
                    //@ts-ignore
                    blocksObjectives={this.state.currentGameMenuConfig.blocksObjectives}
                    startingJournalValue={pauseJournalContent}
                    onResume={() => {
                        this.setState({
                            pauseScreen: false
                        });

                        this.sendOnResume();
                    }}
                    onSaveJournal={(preFeedback: string) => {
                        this.setState({
                            pauseScreen: false,
                            loadingGame: true,
                            renderGameLocally: true
                        });

                        // Push this first round into the simulator
                        this.sendFirstRoundData(JSON.stringify(this.state.firstRoundData));

                        this.handlePostPreFeedback(preFeedback, () => {
                            this.sendOnResume();

                            //this.sendPlanData(preFeedback);
                        });
                    }}
                />
            </Card>
        </div>
    }

    /*
    Tutorial
    */

    getConfigByName = (configName: string) => {
        const FULL_MENU_CONFIG = this.getMenuConfig();
        let matchingConfig = undefined;

        each(FULL_MENU_CONFIG.categories, (category: any) => {
            const {
                items,
            } = category;

            each(items, item => {
                const title = item.title.trim();

                if (title === configName) {
                    matchingConfig = item;
                }
            });
        });

        return matchingConfig;
    }

    findAndContinueOnConfig = (configName: string) => {
        const config = this.getConfigByName(configName);

        if (config !== undefined) {
            this.handlePlayButtonClick(config);
        }
    }

    renderResults = () => {
        const {
            user
        } = this.props;

        if (user.classicMode === 2) {

            let resultsHolder: any = undefined;

            //@ts-ignore
            if (this.state.currentGameMenuConfig!.classicLP === true) {
                resultsHolder = <ClassicLPResultsScreen
                    user={this.props.user}
                    gameID={this.state.currentGame}
                    //@ts-ignore
                    needsJournal={true}
                    savedPreJournal={this.state.savedPreJournal}
                    menuConfig={this.state.currentGameMenuConfig}
                    //@ts-ignore
                    successMessage={this.state.currentGameMenuConfig!.successMessage}
                    //@ts-ignore
                    failureMessage={this.state.currentGameMenuConfig!.failureMessage}
                    onResume={() => {

                    }}
                    onSaveJournal={(preFeedback: string, redo: boolean) => {
                        this.setState({
                            loadingOverviewData: true
                        });

                        this.showShelf();

                        this.handlePostPostFeedback(preFeedback, () => {
                            // Re load our progress data on submit of the feedback
                            executeQueryGetAuth("progress/user/" + this.props.user.id + "/overview", {}, this.props.user, (overviewData) => {
                                let existingMenuConfig = this.state.currentGameMenuConfig;

                                //@ts-ignore
                                existingMenuConfig['cachedDefaultJournal'] = preFeedback;

                                this.refreshClassicProgress(() => {
                                    this.setState({
                                        currentGame: '',
                                        loadingGame: false,
                                        pauseScreen: false,
                                        showJournal: false,
                                        latestObjectiveData: undefined,
                                        currentScenario: '',
                                        currentGameMenuConfig: {},
                                        sHowResultsScreen: false,
                                        savedPreJournal: '',
                                        overviewData: overviewData.body,
                                        loadingOverviewData: false,
                                        graphicConfig: undefined,
                                    }, () => {
                                        if (redo) {
                                            // Immediately trigger the create game for what we just had
                                            this.setState({
                                                loadingGame: true,
                                                currentGameMenuConfig: existingMenuConfig
                                            }, () => {
                                                //@ts-ignore
                                                this.handlePlayButtonClick(existingMenuConfig, true, preFeedback);
                                            });
                                        }
                                        else {
                                            // If it was a normal continue, check to see if they should continue to another config
                                            //@ts-ignore
                                            if (existingMenuConfig.nextConfig !== undefined) {
                                                //@ts-ignore
                                                this.findAndContinueOnConfig(existingMenuConfig.nextConfig);
                                            }
                                        }
                                    });
                                });
                            });

                        });
                    }}
                />
            }
            else {
                resultsHolder = <ClassicResultsScreen
                    user={this.props.user}
                    gameID={this.state.currentGame}
                    //@ts-ignore
                    needsJournal={true}
                    savedPreJournal={this.state.savedPreJournal}
                    menuConfig={this.state.currentGameMenuConfig}
                    onResume={() => {

                    }}
                    onSaveJournal={(preFeedback: string, redo: boolean, simulatedData: any) => {
                        this.setState({
                            loadingOverviewData: true,
                            cachedSimulatedData: simulatedData
                        });

                        this.handlePostPostFeedback(preFeedback, () => {
                            // Re load our progress data on submit of the feedback
                            executeQueryGetAuth("progress/user/" + this.props.user.id + "/overview", {}, this.props.user, (overviewData) => {
                                let existingMenuConfig = this.state.currentGameMenuConfig;

                                //@ts-ignore
                                existingMenuConfig['cachedDefaultJournal'] = preFeedback;

                                this.refreshClassicProgress(() => {
                                    this.setState({
                                        currentGame: '',
                                        loadingGame: false,
                                        pauseScreen: false,
                                        showJournal: false,
                                        latestObjectiveData: undefined,
                                        currentScenario: '',
                                        currentGameMenuConfig: {},
                                        sHowResultsScreen: false,
                                        savedPreJournal: '',
                                        overviewData: overviewData.body,
                                        loadingOverviewData: false,
                                        graphicConfig: undefined,
                                    }, () => {
                                        if (redo) {
                                            // Immediately trigger the create game for what we just had
                                            this.setState({
                                                loadingGame: true,
                                                currentGameMenuConfig: existingMenuConfig
                                            }, () => {
                                                //@ts-ignore
                                                this.handlePlayButtonClick(existingMenuConfig);
                                            });
                                        }
                                        else {
                                            // If it was a normal continue, check to see if they should continue to another config
                                            //@ts-ignore
                                            if (existingMenuConfig.nextConfig !== undefined) {
                                                //@ts-ignore
                                                this.findAndContinueOnConfig(existingMenuConfig.nextConfig);
                                            }
                                        }
                                    });
                                });
                            });
                        });
                    }}
                />
            }

            return <div className="kryParent" id="kryRoot">
                <Card className="kryParentCard" interactive={false} elevation={Elevation.ONE}>
                    {resultsHolder}
                </Card>
            </div>
        }

        if (this.state.currentGameMenuConfig && this.state.currentGameMenuConfig.leadershipLesson === true) {
            return <div className="kryParent" id="kryRoot">
                <Card className="kryParentCard" interactive={false} elevation={Elevation.ONE}>
                    {this.state.loadingOverviewData ? <div style={{ display: 'block', width: '100%', height: '100%' }}><div style={{ display: 'block', margin: 'auto' }}><Spinner /></div></div> : <LessonResultsScreen
                        user={this.props.user}
                        gameID={this.state.currentGame}
                        //@ts-ignore
                        needsJournal={true}
                        savedPreJournal={this.state.savedPreJournal}
                        menuConfig={this.state.currentGameMenuConfig}
                        promptData={this.state.promptData}
                        progressSoFar={this.state.overviewData}
                        initialStylesV1={this.state.currentGameMenuConfig.initialStylesV1}
                        globalConfigs={this.getGlobalConfigs()}
                        onResume={() => {

                        }}
                        onSaveJournalUsePrefeedback={(preFeedback: string, redo: boolean) => {
                            this.setState({
                                loadingOverviewData: true
                            });

                            this.handlePostPostFeedback(preFeedback, () => {
                                // Re load our progress data on submit of the feedback
                                executeQueryGetAuth("progress/user/" + this.props.user.id + "/overview", {}, this.props.user, (overviewData) => {
                                    let existingMenuConfig = clone(this.state.currentGameMenuConfig);

                                    //@ts-ignore
                                    existingMenuConfig['cachedDefaultJournal'] = preFeedback;

                                    this.setState({
                                        currentGame: '',
                                        loadingGame: false,
                                        pauseScreen: false,
                                        showJournal: false,
                                        latestObjectiveData: undefined,
                                        currentScenario: '',
                                        currentGameMenuConfig: {},
                                        sHowResultsScreen: false,
                                        overviewData: overviewData.body,
                                        loadingOverviewData: false,
                                        graphicConfig: undefined,
                                    }, () => {
                                        if (redo) {
                                            // Immediately trigger the create game for what we just had
                                            this.setState({
                                                loadingGame: true,
                                                currentGameMenuConfig: existingMenuConfig,
                                                savedPreJournal: preFeedback
                                            }, () => {
                                                console.log(existingMenuConfig);
                                                //@ts-ignore
                                                this.handlePlayButtonClick(existingMenuConfig);
                                            });
                                        }
                                        else {
                                            this.setState({
                                                savedPreJournal: ""
                                            });

                                            // If it was a normal continue, check to see if they should continue to another config
                                            //@ts-ignore
                                            if (existingMenuConfig.nextConfig !== undefined) {
                                                //@ts-ignore
                                                this.findAndContinueOnConfig(existingMenuConfig.nextConfig);
                                            }
                                        }
                                    });
                                });

                            });
                        }}
                        onSaveJournal={(preFeedback: string, redo: boolean) => {
                            this.setState({
                                loadingOverviewData: true
                            });

                            this.handlePostPostFeedback(preFeedback, () => {
                                // Re load our progress data on submit of the feedback
                                executeQueryGetAuth("progress/user/" + this.props.user.id + "/overview", {}, this.props.user, (overviewData) => {
                                    const existingMenuConfig = this.state.currentGameMenuConfig;



                                    this.setState({
                                        currentGame: '',
                                        loadingGame: false,
                                        pauseScreen: false,
                                        showJournal: false,
                                        latestObjectiveData: undefined,
                                        currentScenario: '',
                                        currentGameMenuConfig: {},
                                        sHowResultsScreen: false,
                                        savedPreJournal: '',
                                        overviewData: overviewData.body,
                                        loadingOverviewData: false,
                                        graphicConfig: undefined,
                                    }, () => {
                                        if (redo) {
                                            //@ts-ignore
                                            existingMenuConfig['cachedDefaultJournal'] = preFeedback;

                                            // Immediately trigger the create game for what we just had
                                            this.setState({
                                                loadingGame: true,
                                                currentGameMenuConfig: existingMenuConfig
                                            }, () => {
                                                //@ts-ignore
                                                this.handlePlayButtonClick(existingMenuConfig, true, preFeedback);
                                            });
                                        }
                                        else {
                                            // If it was a normal continue, check to see if they should continue to another config
                                            //@ts-ignore
                                            if (existingMenuConfig.nextConfig !== undefined) {
                                                //@ts-ignore
                                                this.findAndContinueOnConfig(existingMenuConfig.nextConfig);
                                            }
                                        }
                                    });
                                });

                            });
                        }}
                    />}
                </Card>
            </div>
        }

        return <div className="kryParent" id="kryRoot">
            <Card className="kryParentCard" interactive={false} elevation={Elevation.ONE}>
                {this.state.loadingOverviewData ? <div style={{ display: 'block', width: '100%', height: '100%' }}><div style={{ display: 'block', margin: 'auto' }}><Spinner /></div></div> : <ResultsScreen promptData={this.state.promptData}
                    user={this.props.user}
                    gameID={this.state.currentGame}
                    //@ts-ignore
                    needsJournal={true}
                    savedPreJournal={this.state.savedPreJournal}
                    menuConfig={this.state.currentGameMenuConfig}
                    progressSoFar={this.state.overviewData}
                    initialStylesV1={this.state.currentGameMenuConfig.initialStylesV1}
                    globalConfigs={this.getGlobalConfigs()}
                    onResume={() => {

                    }}
                    onSaveJournalUsePrefeedback={(preFeedback: string, redo: boolean) => {
                        this.setState({
                            loadingOverviewData: true
                        });

                        this.handlePostPostFeedback(preFeedback, () => {
                            // Re load our progress data on submit of the feedback
                            executeQueryGetAuth("progress/user/" + this.props.user.id + "/overview", {}, this.props.user, (overviewData) => {
                                let existingMenuConfig = clone(this.state.currentGameMenuConfig);

                                //@ts-ignore
                                existingMenuConfig['cachedDefaultJournal'] = preFeedback;

                                this.setState({
                                    currentGame: '',
                                    loadingGame: false,
                                    pauseScreen: false,
                                    showJournal: false,
                                    latestObjectiveData: undefined,
                                    currentScenario: '',
                                    currentGameMenuConfig: {},
                                    sHowResultsScreen: false,
                                    savedPreJournal: '',
                                    overviewData: overviewData.body,
                                    loadingOverviewData: false,
                                    graphicConfig: undefined,
                                }, () => {
                                    if (redo) {
                                        // Immediately trigger the create game for what we just had
                                        this.setState({
                                            loadingGame: true,
                                            currentGameMenuConfig: existingMenuConfig
                                        }, () => {
                                            //@ts-ignore
                                            this.handlePlayButtonClick(existingMenuConfig);
                                        });
                                    }
                                    else {
                                        // If it was a normal continue, check to see if they should continue to another config
                                        //@ts-ignore
                                        if (existingMenuConfig.nextConfig !== undefined) {
                                            //@ts-ignore
                                            this.findAndContinueOnConfig(existingMenuConfig.nextConfig);
                                        }
                                    }
                                });
                            });

                        });
                    }}
                    onSaveJournal={(preFeedback: string, redo: boolean) => {
                        this.setState({
                            loadingOverviewData: true
                        });

                        this.handlePostPostFeedback(preFeedback, () => {
                            // Re load our progress data on submit of the feedback
                            executeQueryGetAuth("progress/user/" + this.props.user.id + "/overview", {}, this.props.user, (overviewData) => {
                                const existingMenuConfig = this.state.currentGameMenuConfig;



                                this.setState({
                                    currentGame: '',
                                    loadingGame: false,
                                    pauseScreen: false,
                                    showJournal: false,
                                    latestObjectiveData: undefined,
                                    currentScenario: '',
                                    currentGameMenuConfig: {},
                                    sHowResultsScreen: false,
                                    savedPreJournal: '',
                                    overviewData: overviewData.body,
                                    loadingOverviewData: false,
                                    graphicConfig: undefined,
                                }, () => {
                                    if (redo) {
                                        //@ts-ignore
                                        existingMenuConfig['cachedDefaultJournal'] = preFeedback;

                                        // Immediately trigger the create game for what we just had
                                        this.setState({
                                            loadingGame: true,
                                            currentGameMenuConfig: existingMenuConfig
                                        }, () => {
                                            //@ts-ignore
                                            this.handlePlayButtonClick(existingMenuConfig);
                                        });
                                    }
                                    else {
                                        // If it was a normal continue, check to see if they should continue to another config
                                        //@ts-ignore
                                        if (existingMenuConfig.nextConfig !== undefined) {
                                            //@ts-ignore
                                            this.findAndContinueOnConfig(existingMenuConfig.nextConfig);
                                        }
                                    }
                                });
                            });

                        });
                    }}
                />}
            </Card>
        </div>
    }

    // Prompt them for a journal entry
    renderJournal = () => {
        const {
            currentGameMenuConfig
        } = this.state;

        //@ts-ignore
        const journalGraphic = currentGameMenuConfig ? currentGameMenuConfig!.journalGraphic : '';
        //@ts-ignore
        const journalAudio = currentGameMenuConfig ? currentGameMenuConfig!.journalAudio : '';
        //@ts-ignore
        const journalGraphicSub1 = currentGameMenuConfig ? currentGameMenuConfig!.journalGraphicSub1 : '';
        //@ts-ignore
        const journalGraphicSub2 = currentGameMenuConfig ? currentGameMenuConfig!.journalGraphicSub2 : '';
        //@ts-ignore
        const journalGrphicPost = currentGameMenuConfig ? currentGameMenuConfig!.journalGrphicPost : '';

        let coreJournal: any = undefined;

        if (this.props.user.classicMode === 2) {
            coreJournal = <ClassicJournalWriter
                //@ts-ignore
                prompt={currentGameMenuConfig.preJournalTitle}
                cachedSimulatedData={this.state.cachedSimulatedData}
                menuConfig={currentGameMenuConfig}
                user={this.props.user}
                gameID={this.state.currentGame}
                //@ts-ignore
                blockObjectives={currentGameMenuConfig.blockObjectives}
                coachingAudio={journalAudio}
                jouranlGraphic={journalGraphic}
                journalGraphicSub1={journalGraphicSub1}
                journalGraphicSub2={journalGraphicSub2}
                journalGrphicPost={journalGrphicPost}
                goBackHome={() => {
                    this.setState({
                        currentGame: '',
                        loadingGame: false,
                        pauseScreen: false,
                        showJournal: false,
                        latestObjectiveData: undefined,
                        currentScenario: '',
                        currentGameMenuConfig: {},
                        sHowResultsScreen: false,
                        savedPreJournal: '',
                        loadingOverviewData: false,
                        graphicConfig: undefined,
                    });

                    // Make sure the scene is reset in the simulation
                    this.pushFunction("unity_onSoftReset", "-");
                }}
                //@ts-ignore
                forLP={currentGameMenuConfig.classicLP}
                recieveJournal={(journalEntry: string) => {
                    this.setState({
                        showJournal: false,
                        loadingGame: true,
                        renderGameLocally: true
                    });

                    // Push this first round into the simulator
                    this.sendFirstRoundData(JSON.stringify(this.state.firstRoundData));

                    let attemptToFindPreJournalReadable = '';

                    try {
                        const fb = JSON.parse(journalEntry);

                        if (typeof (fb) === typeof ("array")) {
                            attemptToFindPreJournalReadable = fb[0];
                        }
                        else {
                            attemptToFindPreJournalReadable = fb[Object.keys(fb)[0]];
                        }
                    }
                    catch (e) {
                        attemptToFindPreJournalReadable = journalEntry;
                    }

                    // Save what they typed
                    this.handlePostPreFeedback(attemptToFindPreJournalReadable, () => {
                        this.sendOnResume();

                        this.sendPlanData(attemptToFindPreJournalReadable);
                    });
                }}
            />
        }
        else {
            if (this.props.user.classicMode === 3) {

            }
            else {

                if (currentGameMenuConfig.leadershipLesson === true) {
                    coreJournal = <LessonJournalWriter
                        //@ts-ignore
                        cachedDefaultJournal={currentGameMenuConfig!.cachedDefaultJournal}
                        //@ts-ignore
                        prompt={currentGameMenuConfig.preJournalTitle}
                        user={this.props.user}
                        promptData={this.state.promptData}
                        gameID={this.state.currentGame}
                        //@ts-ignore
                        blockObjectives={currentGameMenuConfig.blockObjectives}
                        //@ts-ignore
                        style={currentGameMenuConfig.title}
                        straightToSim={this.state.straightToSim}
                        showPreGraph={currentGameMenuConfig.showPreGraph}
                        coachingAudio={journalAudio}
                        initialStylesV1={currentGameMenuConfig.initialStylesV1}
                        jouranlGraphic={journalGraphic}
                        goBackHome={() => {
                            this.setState({
                                currentGame: '',
                                loadingGame: false,
                                pauseScreen: false,
                                showJournal: false,
                                latestObjectiveData: undefined,
                                currentScenario: '',
                                currentGameMenuConfig: {},
                                sHowResultsScreen: false,
                                savedPreJournal: '',
                                loadingOverviewData: false,
                                graphicConfig: undefined,
                            });

                            // Make sure the scene is reset in the simulation
                            this.pushFunction("unity_onSoftReset", "-");
                        }}
                        recieveJournal={(journalEntry: string) => {
                            console.log(journalEntry);

                            this.setState({
                                showJournal: false,
                                loadingGame: true,
                                renderGameLocally: true
                            });

                            // Push this first round into the simulator
                            this.sendFirstRoundData(JSON.stringify(this.state.firstRoundData));

                            // Save what they typed
                            this.handlePostPreFeedback(journalEntry, () => {
                                this.sendOnResume();

                                this.sendPlanData(journalEntry);
                            });
                        }}
                    />
                }
                else {
                    coreJournal = <JournalWriter
                        //@ts-ignore
                        cachedDefaultJournal={currentGameMenuConfig!.cachedDefaultJournal}
                        //@ts-ignore
                        prompt={currentGameMenuConfig.preJournalTitle}
                        promptData={this.state.promptData}
                        slug={currentGameMenuConfig.slug}
                        user={this.props.user}
                        gameID={this.state.currentGame}
                        //@ts-ignore
                        blockObjectives={currentGameMenuConfig.blockObjectives}
                        //@ts-ignore
                        style={currentGameMenuConfig.title}
                        showPreGraph={currentGameMenuConfig.showPreGraph}
                        coachingAudio={journalAudio}
                        initialStylesV1={currentGameMenuConfig.initialStylesV1}
                        jouranlGraphic={journalGraphic}
                        goBackHome={() => {
                            this.setState({
                                currentGame: '',
                                loadingGame: false,
                                pauseScreen: false,
                                showJournal: false,
                                latestObjectiveData: undefined,
                                currentScenario: '',
                                currentGameMenuConfig: {},
                                sHowResultsScreen: false,
                                savedPreJournal: '',
                                loadingOverviewData: false,
                                graphicConfig: undefined,
                            });

                            // Make sure the scene is reset in the simulation
                            this.pushFunction("unity_onSoftReset", "-");
                        }}
                        recieveJournal={(journalEntry: string) => {
                            this.setState({
                                showJournal: false,
                                loadingGame: true,
                                renderGameLocally: true
                            });

                            // Push this first round into the simulator
                            this.sendFirstRoundData(JSON.stringify(this.state.firstRoundData));

                            // Save what they typed
                            this.handlePostPreFeedback(journalEntry, () => {
                                this.sendOnResume();

                                this.sendPlanData(journalEntry);
                            });
                        }}
                    />
                }
            }
        }

        if (currentGameMenuConfig.hybridJournalWriterEnabled) {
            coreJournal = <JournalWriter2
                //@ts-ignore
                cachedDefaultJournal={currentGameMenuConfig!.cachedDefaultJournal}
                //@ts-ignore
                prompt={currentGameMenuConfig.preJournalTitle}
                user={this.props.user}
                gameID={this.state.currentGame}
                //@ts-ignore
                blockObjectives={currentGameMenuConfig.blockObjectives}
                //@ts-ignore
                style={currentGameMenuConfig.title}
                coachingAudio={journalAudio}
                jouranlGraphic={journalGraphic}
                recieveJournal={(journalEntry: string) => {
                    this.setState({
                        showJournal: false,
                        loadingGame: true,
                        renderGameLocally: true
                    });

                    // Push this first round into the simulator
                    this.sendFirstRoundData(JSON.stringify(this.state.firstRoundData));

                    // Save what they typed
                    this.handlePostPreFeedback(journalEntry, () => {
                        this.sendOnResume();

                        this.sendPlanData(journalEntry);
                    });
                }}
            />
        }

        return <div className="kryParent" id="kryRoot">
            <Card className="kryParentCard" interactive={false} elevation={Elevation.ONE}>
                {coreJournal}
            </Card>
        </div>
    }

    renderGraphic = () => {
        const {
            graphicConfig
        } = this.state;

        return <div className="kryParent" id="kryRoot">
            <Card className="kryParentCard" interactive={false} elevation={Elevation.ONE}>
                <GraphicView
                    //@ts-ignore
                    coachingAudio={graphicConfig.journalAudio}
                    //@ts-ignore
                    jouranlGraphic={graphicConfig.journalGraphic}
                    close={() => {
                        const existingMenuConfig = graphicConfig;

                        // Track completion of graphic scenes by incrementing attempts
                        if (existingMenuConfig && existingMenuConfig.slug) {
                            // Find the matching entry in the menu config and increment attempts
                            const menuConfig = this.getMenuConfig();
                            each(menuConfig.categories, (category: any) => {
                                each(category.items, (item: any) => {
                                    if (item.slug === existingMenuConfig.slug) {
                                        item.attempts = (item.attempts || 0) + 1;
                                    }
                                });
                            });
                        }

                        this.setState({
                            currentGame: '',
                            loadingGame: false,
                            pauseScreen: false,
                            showJournal: false,
                            latestObjectiveData: undefined,
                            currentScenario: '',
                            currentGameMenuConfig: {},
                            sHowResultsScreen: false,
                            savedPreJournal: '',
                            loadingOverviewData: false,
                            graphicConfig: undefined
                        });

                        // If it was a normal continue, check to see if they should continue to another config
                        //@ts-ignore
                        if (existingMenuConfig.nextConfig !== undefined) {
                            //@ts-ignore
                            this.findAndContinueOnConfig(existingMenuConfig.nextConfig);
                        }
                    }}
                />
            </Card>
        </div>
    }

    renderLoadingGameScreen() {
        if (this.getShouldGameRender()) {
            return <span />
        }

        return <span>
            <div style={{
                display: 'flex',
                width: '100%',
                height: '100%',
                justifyContent: 'center'
            }}><Spinner size={200} /></div>
            <img src="assets/img/v.png" style={{ width: '100px', display: 'block', position: 'absolute', bottom: '40px', right: '40px' }} >
            </img>
        </span>
    }

    getMenuConfig = () => {
        const {
            overviewData,
            customMenuConfig
        } = this.state;

        const {
            user
        } = this.props;

        let parsedMenuConfig: { categories: any[] } = {
            categories: []
        }

        let menuConfig = clone(this.state.remoteConfig);

        if (user.classicMode === 2) {
            //@ts-ignore
            menuConfig = clone(this.state.remoteConfig);
        }

        if (customMenuConfig !== undefined) {
            //@ts-ignore
            menuConfig = clone(customMenuConfig);
        }

        if (user.classicMode === 2) {
            each(menuConfig.categories, category => {

                for (let i = 0; i < category.items.length; i++) {
                    const {
                        classicProgress
                    } = this.state;

                    const slug = category.items[i].slug;

                    if (slug === 'Tutorial') {
                        //@ts-ignore
                        category.items[i].attempts = parseInt(this.props.user.tutorial);

                        if (this.state.locallyTutorialDone) {
                            category.items[i].attempts = 1;
                        }
                    }
                    else {
                        const overview = classicProgress[slug];

                        if (overview !== undefined) {
                            category.items[i].bestPlay = parseInt(overview['best-score']);
                            category.items[i].attempts = parseInt(overview['total-plays']);
                        }
                    }
                }

                parsedMenuConfig.categories.push(category);
            });
        }
        else {
            each(menuConfig.categories, category => {

                for (let i = 0; i < category.items.length; i++) {
                    const slug = category.items[i].slug;

                    const thisOverview = overviewData[slug];

                    if (thisOverview !== undefined) {
                        category.items[i].bestPlay = parseInt(thisOverview['best-score']);
                        category.items[i].attempts = parseInt(thisOverview['total-plays']);
                    }

                    if (category.items[i].title.trim() === "Getting Started") {
                        category.items[i].attempts = parseInt(this.props.user.tutorial);
                    }

                    if (category.items[i].title.trim() === "Getting Work Done") {
                        category.items[i].attempts = parseInt(thisOverview['total-plays-above-seventy']);
                    }

                    if (category.items[i].title.trim() === "Getting Access to Hidden Ideas") {
                        category.items[i].attempts = parseInt(thisOverview['total-plays-above-seventy']);
                    }

                    if (category.items[i].title.trim() === "Getting Commitment") {
                        category.items[i].attempts = parseInt(thisOverview['total-plays-above-seventy']);
                    }
                }

                parsedMenuConfig.categories.push(category);
            });
        }

        return parsedMenuConfig;
    }

    getAppVersionName = () => {
        const {
            user
        } = this.props;

        //@ts-ignore
        if (user.classicMode === 2 || user.classicMode === '2') {
            return translateKey('vleader.classicEdition');
        }

        return translateKey('vleader.labEdition');
    }

    getColumns() {
        return [{
            Header: "Video",
            accessor: 'title',
            Cell: (props) => {
                const hasLink = props.original.link !== "";

                if (hasLink) {
                    return props.value;
                }

                return <strong>{props.value}</strong>
            },
            width: 250
        }, {
            Header: "",
            accessor: 'link',
            Cell: (props) => {
                if (props.value === "") {
                    return <span></span>
                }
                return <div>
                    <Dialog style={{ width: '70vw' }} isOpen={this.state.isOpen[props.value]} onClose={() => {
                        this.setState({ isOpen: { ...this.state.isOpen, [props.value]: false } })
                    }}>
                        <div style={{ width: '70vw', display: 'block', margin: 'auto' }}>
                            <video width="100%" controls>
                                <source src={props.value} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </Dialog>
                    <Button intent={Intent.PRIMARY} style={{ width: '100%' }} icon="play" text="Play Video" onClick={() => {
                        this.setState({ isOpen: { ...this.state.isOpen, [props.value]: true } })
                    }} />
                </div>
            }
        }]
    }

    renderYourJournal = () => {
        const {
            user
        } = this.props;

        return <SingleOverview defaultSelectedTab={"overview_nav_2"} hideDownloadPrompt={true} user={user} forceNoEdit={false} targetUserID={user.id.toString()} />
    }

    renderPrimarymenu = () => {

        // MENU_CONFIG
        let elements: JSX.Element[] = [];

        //@ts-ignore
        if (this.state.classDetails.can_users_see_videos === 1) {
            elements.push(
                <span>
                    <Button icon="play" style={{ width: '100%', marginBottom: '10px', fontSize: '21px' }} large onClick={() => {
                        // open educator resources
                        this.setState({ showEducatorResources: !this.state.showEducatorResources })
                    }}>Educator Resources</Button>
                    <Collapse isOpen={this.state.showEducatorResources}>
                        <div style={{ width: '500px', margin: 'auto' }}>
                            <ReactTable style={{ marginTop: '20px', marginBottom: '20px' }} columns={this.getColumns()}
                                //@ts-ignore
                                data={this.state.educatorResources ? this.state.educatorResources : []}
                                //@ts-ignore
                                pageSize={this.state.educatorResources ? this.state.educatorResources.length : 0}
                                showPagination={false}
                                showPageSizeOptions={false} />
                        </div>
                    </Collapse>
                </span>
            )
        }

        elements.push(
            <span>
                <Button intent={Intent.PRIMARY} icon="history" style={{ width: '100%', marginBottom: '10px', fontSize: '21px' }} large onClick={() => {
                    // open educator resources
                    this.setState({ showYourJournal: !this.state.showYourJournal })
                }}>Your Journal</Button>
                <Collapse isOpen={this.state.showYourJournal}>
                    {this.renderYourJournal()}
                </Collapse>
            </span>
        )

        const FULL_MENU_CONFIG = this.getMenuConfig();

        // Check if there's unrated coaching - if so, disable all modules
        const hasUnratedCoaching = this.doesCoachingQueueHaveSomething(this.state.queuedPersonalCoaching);

        each(FULL_MENU_CONFIG.categories, (category: any, categoryIndex: number) => {
            const {
                sHowBestPlay,
                items,
                title
            } = category;

            let isDisabled = false;
            let graphView = <span></span>

            // If there's unrated coaching, disable all modules
            if (hasUnratedCoaching) {
                isDisabled = true;
            }

            // Check if previous modules are completed before allowing access to this module
            let moduleDisabledReason = '';
            // TEMPORARILY DISABLED: Module dependency checking
            /*
            if (categoryIndex > 0 && !hasUnratedCoaching) {
                const previousCategories = FULL_MENU_CONFIG.categories.slice(0, categoryIndex);
                
                for (let i = 0; i < previousCategories.length; i++) {
                    const prevCategory = previousCategories[i];
                    const allItemsCompleted = prevCategory.items.every((item: any) => {
                        if (!item.slug) return true; // Skip items without slugs
                        
                        const overviewData = this.state.overviewData[item.slug];
                        if (!overviewData) return false;
                        
                        const totalPlays = parseInt(overviewData['total-plays'] || '0');
                        return totalPlays > 0; // At least one attempt
                    });
                    
                    if (!allItemsCompleted) {
                        isDisabled = true;
                        moduleDisabledReason = `Complete all items in "${prevCategory.title}" before accessing this module`;
                        break;
                    }
                }
            }
            */

            if (title.trim() === 'Module 1: Using Intent-based Communication') {
                //@ts-ignore
                if (this.state.classDetails.access_tutorial === 0) {
                    isDisabled = true;
                }
            }

            if (title.trim() === 'Module 2: Leadership Styles') {
                //@ts-ignore
                if (this.state.classDetails.access_scenario_1 === 0) {
                    isDisabled = true;
                }
                else {
                    // graphView = <span style={{marginTop: '10px', marginBottom: '10px'}}>
                    //     <SingleOverview defaultSelectedTab={"overview_nav_2"} hideDownloadPrompt={true} forceNoEdit={false} targetUserID={this.props.user.id.toString()}  chartMode={true} chartScenario='scenario_1' user={this.props.user} />
                    // </span>
                }
            }

            if (title.trim() === "Module 3: Conflict in Teams") {
                //@ts-ignore
                if (this.state.classDetails.access_scenario_2 === 0) {
                    isDisabled = true;
                }
            }

            if (title.trim() === "Module 4: Group Dynamics") {
                //@ts-ignore
                if (this.state.classDetails.access_scenario_3 === 0) {
                    isDisabled = true;
                }
            }

            if (title.trim() === "Module 5: Crisis and Opportunity") {
                //@ts-ignore
                if (this.state.classDetails.access_scenario_4 === 0) {
                    isDisabled = true;
                }
            }

            if (title.trim() === 'Module 1: Intent-based Communication') {
                //@ts-ignore
                if (this.state.classDetails.access_tutorial === 0) {
                    isDisabled = true;
                }
            }

            if (title.trim() === 'Module 2: Transforming Relationships') {
                //@ts-ignore
                if (this.state.classDetails.access_scenario_1 === 0) {
                    isDisabled = true;
                }
            }

            if (title.trim() === "Opportunities in Conflict") {
                //@ts-ignore
                if (this.state.classDetails.access_scenario_2 === 0) {
                    isDisabled = true;
                }
            }

            if (title.trim() === "Facilitating Change") {
                //@ts-ignore
                if (this.state.classDetails.access_scenario_3 === 0) {
                    isDisabled = true;
                }
            }

            if (title.trim() === "Module 5: Crisis and Opportunity") {
                //@ts-ignore
                if (this.state.classDetails.access_scenario_4 === 0) {
                    isDisabled = true;
                }
            }

            const moduleButton = <Button intent={Intent.SUCCESS} style={{ width: '100%', marginBottom: '10px', fontSize: '21px' }} large onClick={() => {
                this.toggleSlugOpen(title);
            }} disabled={isDisabled}>{title}</Button>;

            elements.push(
                <span>
                    {isDisabled && moduleDisabledReason ? (
                        <Tooltip 
                            content={moduleDisabledReason} 
                            position="top"
                            targetProps={{ style: { width: '100%' } }}
                        >
                            {moduleButton}
                        </Tooltip>
                    ) : moduleButton}
                    <Collapse isOpen={this.getIsSlugOpen(title)}>
                        {graphView}
                        <span style={{ display: 'block', marginBottom: '10px' }}>
                            {sHowBestPlay ? this.renderFullTable(items) : this.renderBasicTable(items)}
                        </span>
                    </Collapse>
                </span>
            );
        });

        // TODO: remove once we don't need the react player snip
        // elements.push(
        //     <span>
        //         <Button intent={Intent.SUCCESS} style={{ width: '100%', marginBottom: '10px', fontSize: '21px' }} large onClick={() => {
        //             this.toggleSlugOpen("youtube");

        //         }}>Video Test</Button>
        //         <Collapse isOpen={this.getIsSlugOpen("youtube")}>
        //             <span style={{ display: 'block', marginBottom: '10px' }}>
        //             <ReactPlayer
        //                 url="https://www.youtube.com/watch?v=bHWgc5MPnPA"
        //             />
        //             </span>
        //         </Collapse>
        //     </span>
        // );

        return <span>
            <img style={{ marginBottom: '30px', marginTop: '20px' }} className={"login-header-image"} src="assets/img/logo.png" onClick={() => {

            }} />
            <div className="appVersionName">
                {this.getAppVersionName()}
            </div>
            {this.renderCoachingAlert()}
            {elements}
        </span>
    }

    // Render a nice grey bar across the top of the menu, with useful info and actions in it
    renderUserInfoCard = () => {
        return <span style={{ display: 'block', width: 'auto', marginLeft: '-20px', marginRight: '-20px', paddingLeft: '20px', paddingRight: '20px', marginTop: '-20px', paddingTop: '20px', backgroundColor: '#ededed', height: '40px' }}>
            <span style={{ position: 'relative', top: '-5px' }}>
                <Icon icon="person"></Icon>
                <span style={{ paddingLeft: '15px' }}>{this.props.user.first + " " + this.props.user.last + " (" + this.props.user.email + ")"}</span>
            </span>
            <span style={{ float: 'right', position: 'relative', top: '-15px' }}>
                <Button intent={Intent.NONE} onClick={() => { this.handlePortalSwitch(); }}>Portal</Button>
                <Button style={{ marginLeft: '15px' }} intent={Intent.NONE} onClick={() => { this.handleGameLogout(); }}>{translateKey('vleader.logOut')}</Button>
                <Button style={{ marginLeft: '15px' }} onClick={() => { this.handleGameExit(); }} intent={Intent.NONE}>{translateKey('vleader.exit')}</Button>
            </span>
            <div className="clearfix" />
        </span>
    }

    renderVersionInfo = () => {
        const currentVersion = window["CURRENT_SOFTWARE_VERSION"] ? window["CURRENT_SOFTWARE_VERSION"] : '0.0';

        return <span style={{ display: 'block', width: '100%' }}>
            <p style={{ textAlign: 'center', fontSize: '12px', marginTop: '10px', color: '#bfbfbf' }}>{currentVersion}</p>
        </span>
    }

    markMessageRead(existingQueue: any, _message: any) {
        let queue = clone(existingQueue);
        let newQueue: any[] = [];

        each(queue, q => {
            if (q.coachingID === _message.coachingID) {
                q.viewed = 1;
            }

            newQueue.push(q);
        });

        return newQueue;
    }

    renderCoachingMessage = (message: PersonalCoaching) => {
        //@ts-ignore
        const viewed = message.viewed === 1 || message.viewed === "1";

        return <Callout icon={<img style={{ height: '30px', marginTop: '-20px' }} src="assets/img/manager-svgrepo-com.svg" />} style={{ maxWidth: '600px', paddingLeft: '10px', margin: 'auto', marginBottom: '20px' }} intent={viewed ? Intent.NONE : Intent.PRIMARY}>
            <strong>
                {moment(message.created).format("LL")}
            </strong>
            <div style={{
                background: 'white',
                borderRadius: '9px',
                padding: '10px',
                marginBottom: '10px'
            }}>
                <p style={{ overflowWrap: 'break-word', overflow: 'hidden', whiteSpace: 'pre-wrap' }}>
                    <strong>Coach:</strong><br />{message.coaching}
                </p>
            </div>
            {viewed ? <span /> : <span>
                <Button style={{ marginRight: '5px' }} intent={Intent.PRIMARY} onClick={() => {
                    // Send off a request to mark it read
                    this.handlePostCoachingRead(message.coachingID, "useful", () => {

                    });

                    // Pop this out of the local state
                    const updatedQueue = this.markMessageRead(this.state.queuedPersonalCoaching, message);
                    this.setState({
                        queuedPersonalCoaching: updatedQueue
                    });

                    // Check if all coaching has been rated, if so, close the dialog
                    const hasUnratedCoaching = this.doesCoachingQueueHaveSomething(updatedQueue);
                    if (!hasUnratedCoaching) {
                        this.setState({ coachingOpen: false });
                    }
                }} text="This was Useful" />
                <Button intent={Intent.WARNING} onClick={() => {
                    // Send off a request to mark it read
                    this.handlePostCoachingRead(message.coachingID, "not-useful", () => {

                    });

                    // Pop this out of the local state
                    const updatedQueue = this.markMessageRead(this.state.queuedPersonalCoaching, message);
                    this.setState({
                        queuedPersonalCoaching: updatedQueue
                    });
                }} text="Thanks, But It's Not Useful" /></span>
            }
        </Callout>
    }

    renderCoachingDialog = () => {
        const {
            queuedPersonalCoaching
        } = this.state;

        const coachingHasNewStuff = this.doesCoachingQueueHaveSomething(queuedPersonalCoaching);
        let coachingMessages: JSX.Element[] = [];

        // Add a header message if there's unrated coaching
        if (coachingHasNewStuff) {
            coachingMessages.push(
                <Callout intent={Intent.PRIMARY} style={{ marginBottom: '15px' }}>
                    <div style={{ lineHeight: '1.5' }}>
                        <strong>📖 Quick Review:</strong> Please take a moment to review your coaching feedback below and let us know how it helped you.
                        <br /><br />
                        Once you've reviewed everything, you can continue with your modules.
                    </div>
                </Callout>
            );
        }

        each(queuedPersonalCoaching, personalCoaching => {
            coachingMessages.push(this.renderCoachingMessage(personalCoaching));
        });

        if (coachingMessages.length === 0) {
            coachingMessages.push(
                <Card>
                    <strong style={{ display: 'block', marginBottom: '5px' }}></strong>
                    <p>
                        There's nothing more to review at this time
                    </p>
                    <Divider />
                </Card>
            )
        }

        return <span style={{ marginTop: '20px' }}>{coachingMessages}</span>
    }

    doesCoachingQueueHaveSomething = (queue: any) => {
        if (queue === undefined || queue === null || queue.length === 0) {
            return false;
        }

        for (let i = 0; i < queue.length; i++) {
            if (queue[i].viewed === 0 || queue[i].viewed === "0") {
                return true;
            }
        }

        return false;
    }

    renderCoachingAlert = () => {
        const {
            queuedPersonalCoaching
        } = this.state;

        const coachingHasNewStuff = this.doesCoachingQueueHaveSomething(queuedPersonalCoaching);
        let coachingButtonLabel = coachingHasNewStuff ? '📖 New Coaching Ready - Quick Review' : 'View Your Coaching';

        if (queuedPersonalCoaching && queuedPersonalCoaching.length > 0) {
            coachingButtonLabel += ` (${queuedPersonalCoaching.length})`;
        }

        const coachingButton = <div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center', justifyContent: 'center' }}>
            <img style={{
                height: '170px',
                padding: '10px'
            }} src="assets/img/coach-svgrepo-com.svg" />
            <div style={{
                height: '70px'
            }}>
                <Button className="coaching-button" intent={coachingHasNewStuff ? Intent.WARNING : Intent.NONE} style={{ width: '100%', marginBottom: '10px', fontSize: '24px', display: 'flex', alignItems: 'center', height: '100%' }} large onClick={() => {
                    this.setState({ coachingOpen: !this.state.coachingOpen });
                }} disabled={(queuedPersonalCoaching === undefined) || (queuedPersonalCoaching.length === 0)}>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        alignItems: 'center'
                    }}>
                        {coachingButtonLabel}
                    </div>
                </Button>
            </div>
        </div>

        return <div style={{ marginBottom: '10px' }}>
            {coachingButton}
            <Collapse isOpen={this.state.coachingOpen}>
                {
                    this.renderCoachingDialog()
                }
            </Collapse>
        </div>
    }

    renderAssessMode = () => {
        return <div className="journalParent" style={{ width: '100%' }}>
            <span style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'column', paddingTop: '100px' }}>\

                    <H5 style={{ width: '700px', marginLeft: 'auto', marginRight: 'auto', marginBottom: '20px' }}>Leadership Style Assessment Mode</H5>

                    <div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center', justifyContent: 'center', justifyItems: 'center', marginBottom: '20px' }}>
                        <H3 style={{ width: '700px', height: '400px' }}>You are about to begin an assessment mode play of this module. You have 3 remaining attempts.

                            The Transformational Style objectives will be used to determine your score.

                            If you feel you are not ready, Go Back and use the Mastery: Transformational Style activity
                        </H3>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row' }}>

                        <div style={{ display: 'flex', width: '100%', flexDirection: 'column', alignContent: 'center', justifyContent: 'center', justifyItems: 'center', paddingLeft: '20px' }}>
                            <H4 style={{ width: '400px' }} key={0}>{"Using your prior experience in this scenario, write a plan to succesfully transform the relationship with Oli"}</H4>
                            <TextAreaV2 value={this.state.assessModeInput} onChange={(event) => {
                                this.setState({
                                    assessModeInput: event.target.value
                                });
                            }} className={"journalTextArea"} rows={5} style={{ width: '500px', height: '90px' }}></TextAreaV2>
                        </div>


                        <div style={{ display: 'flex', flexDirection: 'column', paddingRight: '20px' }}>
                            <Button large style={{ display: 'block', width: '400px', marginTop: '10px', height: '60px', marginLeft: 'auto', marginRight: 'auto' }} onClick={() => {
                                //this.props.recieveJournal(this.calculate_journal_as_string());
                                this.setState({
                                    currentGame: '',
                                    loadingGame: false,
                                    pauseScreen: false,
                                    showJournal: false,
                                    latestObjectiveData: undefined,
                                    currentScenario: '',
                                    currentGameMenuConfig: {},
                                    sHowResultsScreen: false,
                                    savedPreJournal: '',
                                    loadingOverviewData: false,
                                    graphicConfig: undefined,
                                    renderAssessMode: false
                                });

                                // Make sure the scene is reset in the simulation
                                this.pushFunction("unity_onSoftReset", "-");
                            }}>Go Back</Button>
                            <Button large style={{ display: 'block', width: '400px', marginTop: '10px', height: '60px', marginLeft: 'auto', marginRight: 'auto' }} onClick={() => {
                                //this.props.recieveJournal(this.calculate_journal_as_string());
                                this.setState({
                                    loadingGame: true
                                });

                                this.handleGameCreation(this.state.currentGameMenuConfig.slug, () => {
                                    this.setState({
                                        renderAssessMode: false
                                    })
                                }, undefined);
                            }} intent={Intent.SUCCESS}>Save & Execute your Plan</Button>
                        </div>
                    </div>
                </div>
            </span>
        </div>
    }

    currentScenarioSlug = () => {
        if (this.state.currentGameMenuConfig.slug.includes("scenario_1")) {
            return "scenario_1";
        }
        if (this.state.currentGameMenuConfig.slug.includes("scenario_2")) {
            return "scenario_2";
        }
        if (this.state.currentGameMenuConfig.slug.includes("scenario_3")) {
            return "scenario_3";
        }
        if (this.state.currentGameMenuConfig.slug.includes("scenario_4")) {
            return "scenario_4";
        }
        if (this.state.currentGameMenuConfig.slug.includes("Tutorial")) {
            return "scenario_1";
        }
    }

    renderLearningObjectives = () => {
        // get the current scenario slug
        const scenario_slug = this.currentScenarioSlug();
        
        console.log(scenario_slug);
        console.log(this.state.remoteConfig.learning_objectives);

        const learning_objectives = this.state.remoteConfig.learning_objectives[scenario_slug];

        return this.renderPageWrapper(
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
                <img style={{ marginBottom: '30px', marginTop: '20px' }} className={"login-header-image"} src="assets/img/logo.png" onClick={() => {

                }} />
                <div className="appVersionName">
                    {this.getAppVersionName()}
                </div>
                <div style={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'row' }}>
                    <div style={{ width: '100%', marginRight: '20px' }}>
                        <H1>{learning_objectives.title}</H1>
                        <ul style={{ fontSize: '1.2rem' }}>
                            {learning_objectives.objectives.map((objective: string, index: number) => {
                                return <li key={index}>{objective}</li>
                            })}
                        </ul>
                        <Button style={{ marginTop: '10px', width: '100%', height: '50px' }} intent={Intent.PRIMARY} onClick={() => {
                            this.launchCard("Tutorial");
                            this.setState({ renderLearningObjectives: false });
                        }}>{learning_objectives.buttonLabel}</Button>
                    </div>
                </div>

            </div>);
    }

    renderReviewScreen = () => {
        let prompts = [];

        if (this.state.promptData && this.state.promptData.lab) {
            for (let i = 0; i < this.state.promptData.lab.leadership_styles_review.length; i++) {
                const __prompt = this.state.promptData.lab.leadership_styles_review[i];
                const value = this.state.promptValueLookup[__prompt] !== undefined ? this.state.promptValueLookup[__prompt] : '';

                prompts.push(
                    <div style={{ display: 'flex', width: '100%', flexDirection: 'row', alignContent: 'center', justifyContent: 'center', justifyItems: 'center' }}>
                        <H4 style={{ width: '400px' }} key={i}>{__prompt}</H4>
                        <TextAreaV2 value={value} onChange={(event) => {
                            let newPromptValue = {
                                ...this.state.promptValueLookup
                            }

                            newPromptValue[__prompt] = event.target.value;

                            this.setState({
                                promptValueLookup: newPromptValue
                            });
                        }} className={"journalTextArea"} rows={5} style={{ width: '600px', height: '90px' }}></TextAreaV2>
                    </div>
                );
            }
        }

        return this.renderPageWrapper(
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
                <img style={{ marginBottom: '30px', marginTop: '20px' }} className={"login-header-image"} src="assets/img/logo.png" onClick={() => {

                }} />
                <div className="appVersionName">
                    {this.getAppVersionName()}
                </div>
                <div style={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'column', gap: '10px' }}>
                    <H4 style={{ textAlign: 'center', fontSize: '2rem', paddingTop: '35px', paddingBottom: '35px' }}>Leadership Styles: Module Review</H4>
                    {prompts}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', width: '100%', height: '100%', justifyContent: 'flex-start', alignItems: 'center', paddingTop: '10px' }}>
                        <Button style={{ width: '400px', height: '50px' }} intent={Intent.PRIMARY} onClick={() => {
                            //this.props.recieveJournal(this.calculate_journal_as_string());
                            this.setState({
                                loadingGame: true
                            });

                            this.handleGameCreation(this.state.currentGameMenuConfig.slug, () => {
                                this.setState({
                                    loadingGame: true
                                });


                                let _journalEntry = '';

                                const _keys = Object.keys(this.state.promptValueLookup);
                                let values = [];

                                for (let i = 0; i < _keys.length; i++) {
                                    const _key = _keys[i];
                                    const _value = this.state.promptValueLookup[_key];

                                    values.push(_value);
                                }

                                _journalEntry = values.join("\n");


                                // post the journal entry and resolve it
                                this.handlePostPostFeedback(_journalEntry, () => {
                                    this.setState({
                                        loadingGame: true
                                    });
                                    // Re load our progress data on submit of the feedback
                                    executeQueryGetAuth("progress/user/" + this.props.user.id + "/overview", {}, this.props.user, (overviewData) => {
                                        this.setState({
                                            currentGame: '',
                                            loadingGame: false,
                                            pauseScreen: false,
                                            showJournal: false,
                                            latestObjectiveData: undefined,
                                            currentScenario: '',
                                            currentGameMenuConfig: {},
                                            sHowResultsScreen: false,
                                            savedPreJournal: '',
                                            overviewData: overviewData.body,
                                            loadingOverviewData: false,
                                            graphicConfig: undefined,
                                            showingReviewModule: false
                                        }, () => {
                                            // If it was a normal continue, check to see if they should continue to another config
                                            //@ts-ignore
                                        });
                                    });

                                });
                            }, undefined);

                        }}>Submit</Button>
                        <Button style={{ width: '400px', height: '50px' }} onClick={() => {
                            this.setState({
                                showingReviewModule: false,
                                promptValueLookup: {}
                            });
                        }}>Back</Button>
                    </div>
                </div>

            </div>);
    }

    renderModularPreScreen = () => {
        return this.renderPageWrapper(
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
                <img style={{ marginBottom: '30px', marginTop: '20px' }} className={"login-header-image"} src="assets/img/logo.png" onClick={() => {

                }} />
                <div className="appVersionName">
                    {this.getAppVersionName()}
                </div>
                <div style={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'row', alignContent: 'center', justifyContent: 'center', justifyItems: 'center' }}>
                    <div style={{ flexGrow: '1' }}><img style={{ height: '60vh' }} src="assets/img/coach-svgrepo-com.svg"></img></div>
                    {this.state.modularLoading ? <div style={{ width: '600px', marginRight: '20px' }}><Spinner /></div> : <div style={{ width: '600px', marginRight: '20px' }}>
                        <H4 style={{ maxWidth: '600px' }}>{this.state.promptData.modular.initial}</H4>
                        <TextAreaV2 style={{ width: '100%' }} rows={5} defaultValue={this.state.modularProgress.preScreenText} onChange={(event) => {
                            this.setState({ modularProgress: { ...this.state.modularProgress, preScreenText: event.target.value } });
                        }}></TextAreaV2>
                        <Button style={{ marginTop: '10px', width: '100%', height: '50px' }} intent={Intent.PRIMARY} onClick={() => {
                            //this.setState({ loadingGame: true });
                            this.setState({
                                modularLoading: true
                            });

                            const baseUrl = 'https://drg3dwm9kd.execute-api.us-east-1.amazonaws.com/dev/progress/modular/' + this.state.modularProgress.gameID + '/track?journal=' + this.state.modularProgress.preScreenText;

                            superagent.get(baseUrl).end((err, res) => {
                                this.setState({
                                    modularProgress: { ...this.state.modularProgress, finished: 1 },
                                    modularLoading: false
                                })
                            });

                            // this.handlePostModularPreScreen(this.state.modularProgress.preScreenText, () => {
                            //     this.setState({ loadingGame: false, modularProgress: { ...this.state.modularProgress, finished: 1 } });
                            // });
                        }}>Submit</Button>
                    </div>}
                </div>

            </div>);
    }

    renderSubContent = () => {
        const {
            showJournal,
            currentGame,
            loadingGame,
            pauseScreen,
            sHowResultsScreen,
            loadingOverviewData,
            graphicConfig,
            queuedPersonalCoaching
        } = this.state;

        if (sHowResultsScreen) {
            return this.renderResults();
        }

        if (this.props.user.classicMode !== 2) {
            if (this.state.modularProgress === undefined) {
                return this.renderLoadingGameScreen();
            }
            else {
                if (this.state.modularProgress.finished === 0) {
                    return this.renderModularPreScreen();
                }
            }
        }

        if (this.state.renderLearningObjectives) {
            return this.renderLearningObjectives();
        }

        if (this.state.renderAssessMode) {
            return this.renderAssessMode();
        }

        if (loadingGame || loadingOverviewData) return this.renderLoadingGameScreen();

        if (graphicConfig !== undefined) {
            return this.renderGraphic();
        }

        if (showJournal) {
            return this.renderJournal();
        }

        if (this.state.showingReviewModule) {
            return this.renderReviewScreen();
        }

        if (pauseScreen) {
            return this.renderPause();
        }
        else if (currentGame !== '') {
            return this.renderLoadingGameScreen();
        }

        // Check if there's unrated coaching
        const hasUnratedCoaching = this.doesCoachingQueueHaveSomething(queuedPersonalCoaching);

        return <span>
            {
                this.renderPageWrapper(
                    <span style={{ width: '100%' }}>
                        {this.renderUserInfoCard()}

                        {this.renderPrimarymenu()}
                        
                        {/* Show blocking message if there's unrated coaching */}
                        {hasUnratedCoaching && (
                            <div style={{ 
                                textAlign: 'center', 
                                padding: '40px 20px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                margin: '20px 0',
                                border: '2px solid #1976d2'
                            }}>
                                <H4 style={{ color: '#1976d2', marginBottom: '15px' }}>
                                    📖 Read Your Coaching
                                </H4>
                                <p style={{ fontSize: '16px', color: '#666' }}>
                                    Read your coaching, let us know what you thought of it and then carry on.
                                </p>
                                <Callout intent={Intent.PRIMARY} style={{ marginTop: '20px', maxWidth: '600px', margin: '20px auto 0' }}>
                                    <div style={{ lineHeight: '1.5' }}>
                                        <strong>Quick Review:</strong> Take a moment to review your coaching feedback and let us know how it helped you.
                                    </div>
                                </Callout>
                            </div>
                        )}
                    </span>
                )
            }
            {this.renderVersionInfo()}
        </span>;
    }

    renderUnityLoadingProgress = () => {
        return <ProgressBar intent={Intent.PRIMARY} value={this.state.unityLoadingProgress} />
    }

    renderInitScreen = () => {
        const {
            hasUnityInitalized
        } = this.state;

        if (hasUnityInitalized) return <span></span>

        return <span style={{ display: 'block', position: 'fixed', zIndex: 9999, top: '0px', left: '0px', width: '100vw', height: '100vh', background: 'url(https://cdn.barnyak.com/auto/vleader_loading_blur.png)', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', color: '#f0f0f0' }}>
            <span style={{ display: 'block', width: '400px', margin: 'auto', textAlign: 'center', marginTop: '300px', backgroundColor: 'white', borderRadius: '10px', padding: '50px' }}>
                <H4 style={{ color: '#171717', marginTop: '0', marginBottom: '30px', display: 'block' }}>{translateKey('vleader.preparingSimulation')}</H4>
                {this.renderUnityLoadingProgress()}
            </span>
        </span>
    }

    // Track the business logic of when we should be "rendering" our scenario
    getShouldGameRender = () => {
        const {
            renderGameLocally,
            pauseScreen
        } = this.state;

        if (pauseScreen) return false;

        return renderGameLocally;
    }

    renderDynamicJournal = (config) => {
        let sections: any[] = [];

        for (let i = 0; i < config.length; i++) {
            const {
                prompt
            } = config[i];

            const defaultValue = this.getWrittenJournalFrompPrompt(prompt);

            sections.push(
                <span style={{ width: '100%', flex: 1, alignSelf: 'center', justifyContent: 'top' }}>
                    <H4>{prompt}</H4>
                    <TextAreaV2 defaultValue={defaultValue} onChange={(event) => {
                        this.updateWrittenJournalFrompPrompt(prompt, event.target.value);
                    }} className={"journalTextArea"} rows={5} style={{ width: '100%', height: '90px' }}></TextAreaV2>
                </span>
            );
        }

        return <span style={{ flexShrink: 1, transition: 'all 2s' }}>
            <span style={{ position: 'relative', display: 'flex', flexDirection: 'row' }}>
                {sections}
            </span>
        </span>
    }

    updateWrittenJournalFrompPrompt = (prompt, newValue) => {
        let copy = clone(this.state.writtenJouranl);

        let body = undefined;

        try {
            body = JSON.parse(copy);
        }
        catch (e) {
            body = {};
        }

        body[prompt] = newValue;

        this.setState({ writtenJouranl: JSON.stringify(body) })
    }

    getWrittenJournalFrompPrompt = (prompt) => {
        try {
            const body = JSON.parse(this.state.writtenJouranl);

            return body[prompt];
        }
        catch (e) {
            return this.state.writtenJouranl;
        }
    }

    renderSingleMiscJournal = () => {
        const dynamicConfiguration = getDynamicJournalConfiguration(this.props.user, this.state.currentGameMenuConfig, true);

        if (dynamicConfiguration !== undefined) {
            return this.renderDynamicJournal(dynamicConfiguration);
        }

        return <span />
    }

    renderJournalOverview = () => {
        const {
            preJournalShim,
            savingShimPrompts
        } = this.state;

        if (preJournalShim === undefined) {
            return undefined;
        }

        const {
            loosePrePrompts,
            loosePrompt
        } = preJournalShim;

        const viewable = (loosePrePrompts !== undefined || loosePrompt !== undefined);

        return <Dialog onClose={() => {

        }} enforceFocus isOpen={viewable} >
            {this.renderSingleMiscJournal()}
            <p style={{ float: 'left' }}>Your instructor can use this to help and guide you.</p>
            <Button disabled={savingShimPrompts} intent={Intent.PRIMARY} style={{ float: 'right' }} onClick={() => {
                this.setState({
                    savingShimPrompts: true
                });

                this.saveAllThePromps(this.props.user.id, (data) => {
                    this.setState({
                        preJournalShim: undefined,
                        savingShimPrompts: false
                    });
                })


            }}>Done</Button>
            <div className="clearfix" />
        </Dialog>
    }

    saveAllThePromps = (userID, cb) => {
        let promises: any[] = [];

        const keys = Object.keys(this.state.writtenJouranl);
        for (let i = 0; i < this.state.writtenJouranl.length; i++) {
            const _key = keys[i];
            const _body = this.state.writtenJouranl[_key];

            promises.push(
                new Promise((resolve, reject) => {
                    executeQueryPostAuth("data/lj/user/" + userID, {
                        feedback: _body,
                        prompt: _key
                    }, this.props.user, (data) => {
                        resolve(data)
                    });
                })
            )
        }

        Promise.all(promises).then((data) => {
            cb(data);
        });
    }

    render() {
        const {
            hasUnityInitalized,
            loadingMenuConfigs,
            loadingConfig
        } = this.state;

        if (loadingConfig) {
            return <span>
                <span style={{ display: 'block', position: 'fixed', zIndex: 9999, top: '0px', left: '0px', width: '100vw', height: '100vh', background: 'url(https://cdn.barnyak.com/auto/vleader_loading_blur.png)', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', color: '#f0f0f0' }}>
                    <span style={{ display: 'block', width: '400px', margin: 'auto', textAlign: 'center', marginTop: '300px', backgroundColor: 'white', borderRadius: '10px', padding: '50px' }}>
                        <H4 style={{ color: '#171717', marginTop: '0', marginBottom: '30px', display: 'block' }}>{translateKey('vleader.preparingSimulation')}</H4>
                    </span>
                </span>
            </span>
        }

        let contentSafe = (hasUnityInitalized === true && loadingMenuConfigs === false);

        //contentSafe = true;

        const renderGameLocally = this.getShouldGameRender();

        return <span style={{ "overflow": "hidden !important" }}>
            {this.renderInitScreen()}
            {this.renderJournalOverview()}
            <div className={renderGameLocally ? 'showGameClass gameCanvas' : 'hideGameClass gameCanvas'}>
                <UnityPlayer
                    bindSendMessage={(func) => {
                        this.unityContext = func;
                    }}
                    onLoaded={() => {
                        setTimeout(() => {
                            this.pushFunction("unity_getGender", this.props.user.gender);
                            this.pushFunction("unity_gotLogin", this.props.user.authenticationToken + ";" + this.props.user.id);
                        }, 2000)

                        this.setState({
                            hasUnityInitalized: true
                        });
                    }}
                    progressChange={(progression: number) => {
                        this.setState({
                            unityLoadingProgress: progression
                        });
                    }}
                    pushToWindow={(bundle) => {
                        const aspects = bundle.split('#####');

                        // Pass these into the window heap
                        try {
                            // Use some middleware to properlly format the get round call
                            if (aspects[0] === 'unity_getRound') {

                                // The first csv is actually the round number
                                const baseArgument = aspects[1];

                                const allSplices = baseArgument.split(',');

                                const roundNumber = allSplices[0];

                                const actualAction = baseArgument.replace(roundNumber.toString() + ",", "");

                                //@ts-ignore
                                window.unity_getRound(roundNumber, actualAction);
                            }
                            else {
                                //@ts-ignore
                                window[aspects[0]](aspects[1]);
                            }
                        }
                        catch {

                        }
                    }}
                />
            </div>
            {contentSafe ? this.renderSubContent() : <span />}
            
            {/* Certificate Warning Dialog */}
            <Dialog 
                isOpen={this.state.showCertificateWarning} 
                title="Certificate Access Required"
                onClose={() => this.setState({ 
                    showCertificateWarning: false, 
                    certificateWarningEntry: undefined,
                    showAccessCodeEntry: false,
                    accessCodeValue: '',
                    processingAccessCode: false
                })}
                style={{ width: '600px' }}
            >
                <div style={{ padding: '20px' }}>
                    <h4>Assessment Play Requires Certificate Purchase</h4>
                    <p>
                        This assessment play is only available to students who have purchased a certificate. 
                        You have a maximum of <strong>3 assessment plays</strong> with your certificate purchase.
                    </p>
                    
                    {!this.state.showAccessCodeEntry ? (
                        <div>
                            <p><strong>Your options:</strong></p>
                            <ul>
                                <li>If you have a pre-purchased certificate with an access code, you can enter it below</li>
                                <li>Purchase a certificate now for $39.99 (full price)</li>
                            </ul>
                            
                            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                                <Button 
                                    intent={Intent.PRIMARY} 
                                    style={{ marginRight: '10px' }}
                                    onClick={() => {
                                        this.setState({ showAccessCodeEntry: true });
                                    }}
                                >
                                    Enter Access Code
                                </Button>
                                
                                <Button 
                                    intent={Intent.SUCCESS}
                                    onClick={() => {
                                        // Handle certificate purchase at full price
                                        // Create a purchase transaction for certificate product ID 1 at $39.99
                                        window.open('https://vleader.net/purchase-certificate?price=39.99&context=post-purchase', '_blank');
                                        this.setState({ showCertificateWarning: false, certificateWarningEntry: undefined });
                                    }}
                                >
                                    Purchase Certificate ($39.99)
                                </Button>
                            </div>
                            
                            <div style={{ marginTop: '15px' }}>
                                <Button 
                                    intent={Intent.NONE}
                                    onClick={() => this.setState({ 
                                        showCertificateWarning: false, 
                                        certificateWarningEntry: undefined 
                                    })}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <h5>Enter Your Access Code</h5>
                            <p>If you received a code to redeem your certificate, enter it below:</p>
                            
                            <div style={{ margin: '20px 0', textAlign: 'center' }}>
                                <ReactCodeInput 
                                    onChange={(value) => {
                                        this.setState({ accessCodeValue: value });
                                    }} 
                                    name="certificate-access-code" 
                                    value={this.state.accessCodeValue} 
                                    inputMode="verbatim" 
                                    type='text' 
                                    fields={8} 
                                />
                            </div>
                            
                            <div style={{ marginTop: '20px' }}>
                                <Button 
                                    intent={Intent.SUCCESS}
                                    style={{ marginRight: '10px' }}
                                    disabled={this.state.processingAccessCode || this.state.accessCodeValue.length < 8}
                                    onClick={() => {
                                        this.setState({ processingAccessCode: true });
                                        
                                        executeQueryAuthPostForm("transactions/code/consume", {
                                            user: this.props.user.id,
                                            code: this.state.accessCodeValue
                                        }, (response) => {
                                            // Code was successfully redeemed
                                            window.location.reload();
                                        });
                                    }}
                                >
                                    {this.state.processingAccessCode ? 'Processing...' : 'Redeem Code'}
                                </Button>
                                
                                <Button 
                                    intent={Intent.NONE}
                                    onClick={() => this.setState({ 
                                        showAccessCodeEntry: false,
                                        accessCodeValue: '',
                                        processingAccessCode: false
                                    })}
                                >
                                    Back
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </Dialog>
            
            {/* Assess Warning Dialog */}
            <Dialog 
                isOpen={this.state.showAssessWarning} 
                title="Assessment Play Warning"
                onClose={() => this.setState({ showAssessWarning: false, assessWarningEntry: undefined })}
                style={{ width: '500px' }}
            >
                <div style={{ padding: '20px' }}>
                    <div style={{ marginBottom: '20px' }}>
                        {this.state.assessWarningEntry?.assessWarningText || 
                         'You have a maximum of 3 assessment attempts with your certificate. Use them wisely!'}
                    </div>
                    
                    <div style={{ marginTop: '20px' }}>
                        <Button 
                            intent={Intent.PRIMARY}
                            style={{ marginRight: '10px' }}
                            onClick={() => {
                                // Proceed with the assess play
                                const entry = this.state.assessWarningEntry;
                                this.setState({ showAssessWarning: false, assessWarningEntry: undefined });
                                
                                if (entry) {
                                    this.handlePlayButtonClick(entry);
                                }
                            }}
                        >
                            Continue to Assessment
                        </Button>
                        
                        <Button 
                            intent={Intent.NONE}
                            onClick={() => this.setState({ showAssessWarning: false, assessWarningEntry: undefined })}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Dialog>
        </span>
    }
}

export default ReactTimeout(Kry)
